/**
 * Ramp Configurator
 * Handles slider inputs and dispatches configuration change events
 * Also injects line item properties into the add-to-cart form
 */

(function() {
  'use strict';
  
  // Ramp Allowed Combinations (from CSV)
  // Auto-generated from rampenwerk_product_variants_template.csv
  const RAMP_ALLOWED_COMBOS = [
    { h: 2, l: 15, w: 15 }, { h: 2, l: 15, w: 30 }, { h: 2, l: 15, w: 45 }, { h: 2, l: 15, w: 60 }, { h: 2, l: 15, w: 80 },
    { h: 2, l: 20, w: 15 }, { h: 2, l: 20, w: 30 }, { h: 2, l: 20, w: 45 }, { h: 2, l: 20, w: 60 }, { h: 2, l: 20, w: 80 },
    { h: 3, l: 15, w: 15 }, { h: 3, l: 15, w: 30 }, { h: 3, l: 15, w: 45 }, { h: 3, l: 15, w: 60 }, { h: 3, l: 15, w: 80 },
    { h: 3, l: 20, w: 15 }, { h: 3, l: 20, w: 30 }, { h: 3, l: 20, w: 45 }, { h: 3, l: 20, w: 60 }, { h: 3, l: 20, w: 80 },
    { h: 4, l: 20, w: 15 }, { h: 4, l: 20, w: 30 }, { h: 4, l: 20, w: 45 }, { h: 4, l: 20, w: 60 }, { h: 4, l: 20, w: 80 },
    { h: 4, l: 25, w: 15 }, { h: 4, l: 25, w: 30 }, { h: 4, l: 25, w: 45 }, { h: 4, l: 25, w: 60 }, { h: 4, l: 25, w: 80 },
    { h: 5, l: 20, w: 15 }, { h: 5, l: 20, w: 30 }, { h: 5, l: 20, w: 45 }, { h: 5, l: 20, w: 60 }, { h: 5, l: 20, w: 80 },
    { h: 5, l: 25, w: 15 }, { h: 5, l: 25, w: 30 }, { h: 5, l: 25, w: 45 }, { h: 5, l: 25, w: 60 }, { h: 5, l: 25, w: 80 },
    { h: 6, l: 20, w: 15 }, { h: 6, l: 20, w: 30 }, { h: 6, l: 20, w: 45 }, { h: 6, l: 20, w: 60 }, { h: 6, l: 20, w: 80 },
    { h: 6, l: 25, w: 15 }, { h: 6, l: 25, w: 30 }, { h: 6, l: 25, w: 45 }, { h: 6, l: 25, w: 60 }, { h: 6, l: 25, w: 80 },
    { h: 7, l: 25, w: 15 }, { h: 7, l: 25, w: 30 }, { h: 7, l: 25, w: 45 }, { h: 7, l: 25, w: 60 }, { h: 7, l: 25, w: 80 },
    { h: 8, l: 30, w: 15 }, { h: 8, l: 30, w: 30 }, { h: 8, l: 30, w: 45 }, { h: 8, l: 30, w: 60 }, { h: 8, l: 30, w: 80 },
    { h: 8, l: 40, w: 15 }, { h: 8, l: 40, w: 30 }, { h: 8, l: 40, w: 45 }, { h: 8, l: 40, w: 60 }, { h: 8, l: 40, w: 80 },
    { h: 8, l: 50, w: 15 }, { h: 8, l: 50, w: 30 }, { h: 8, l: 50, w: 45 }, { h: 8, l: 50, w: 60 }, { h: 8, l: 50, w: 80 },
    { h: 9, l: 30, w: 15 }, { h: 9, l: 30, w: 30 }, { h: 9, l: 30, w: 45 }, { h: 9, l: 30, w: 60 }, { h: 9, l: 30, w: 80 },
    { h: 9, l: 40, w: 15 }, { h: 9, l: 40, w: 30 }, { h: 9, l: 40, w: 45 }, { h: 9, l: 40, w: 60 }, { h: 9, l: 40, w: 80 },
    { h: 9, l: 50, w: 15 }, { h: 9, l: 50, w: 30 }, { h: 9, l: 50, w: 45 }, { h: 9, l: 50, w: 60 }, { h: 9, l: 50, w: 80 },
    { h: 10, l: 30, w: 15 }, { h: 10, l: 30, w: 30 }, { h: 10, l: 30, w: 45 }, { h: 10, l: 30, w: 60 }, { h: 10, l: 30, w: 80 },
    { h: 10, l: 40, w: 15 }, { h: 10, l: 40, w: 30 }, { h: 10, l: 40, w: 45 }, { h: 10, l: 40, w: 60 }, { h: 10, l: 40, w: 80 },
    { h: 10, l: 50, w: 15 }, { h: 10, l: 50, w: 30 }, { h: 10, l: 50, w: 45 }, { h: 10, l: 50, w: 60 }, { h: 10, l: 50, w: 80 },
    { h: 13, l: 50, w: 15 }, { h: 13, l: 50, w: 30 }, { h: 13, l: 50, w: 45 }, { h: 13, l: 50, w: 60 }, { h: 13, l: 50, w: 80 },
    { h: 14, l: 50, w: 15 }, { h: 14, l: 50, w: 30 }, { h: 14, l: 50, w: 45 }, { h: 14, l: 50, w: 60 }, { h: 14, l: 50, w: 80 },
    { h: 15, l: 50, w: 15 }, { h: 15, l: 50, w: 30 }, { h: 15, l: 50, w: 45 }, { h: 15, l: 50, w: 60 }, { h: 15, l: 50, w: 80 },
    { h: 16, l: 50, w: 15 }, { h: 16, l: 50, w: 30 }, { h: 16, l: 50, w: 45 }, { h: 16, l: 50, w: 60 }, { h: 16, l: 50, w: 80 },
    { h: 17, l: 50, w: 15 }, { h: 17, l: 50, w: 30 }, { h: 17, l: 50, w: 45 }, { h: 17, l: 50, w: 60 }, { h: 17, l: 50, w: 80 },
    { h: 18, l: 60, w: 15 }, { h: 18, l: 60, w: 30 }, { h: 18, l: 60, w: 45 }, { h: 18, l: 60, w: 60 }, { h: 18, l: 60, w: 80 }
  ];
  
  // Find nearest valid combination using weighted distance
  // score = 3*abs(h-hv) + 1*abs(l-lv) + 1*abs(w-wv)
  function findNearestCombo(heightCm, lengthCm, widthCm) {
    if (RAMP_ALLOWED_COMBOS.length === 0) {
      return null;
    }
    
    let bestCombo = null;
    let bestScore = Infinity;
    
    for (const combo of RAMP_ALLOWED_COMBOS) {
      const score = 3 * Math.abs(combo.h - heightCm) + 
                    1 * Math.abs(combo.l - lengthCm) + 
                    1 * Math.abs(combo.w - widthCm);
      
      if (score < bestScore) {
        bestScore = score;
        bestCombo = combo;
      }
    }
    
    return bestCombo;
  }
  
  // Find matching Shopify variant by option values
  function findMatchingVariant(variants, options, heightCm, lengthCm, widthCm) {
    if (!variants || !options || options.length !== 3) {
      console.warn('[Ramp Config] findMatchingVariant: Missing variants or options');
      return null;
    }
    
    // Find option indices
    let heightIdx = -1;
    let lengthIdx = -1;
    let widthIdx = -1;
    
    options.forEach((option, idx) => {
      const name = option.name.toLowerCase();
      if (name.includes('höhe') || name.includes('height')) {
        heightIdx = idx;
      } else if (name.includes('länge') || name.includes('length')) {
        lengthIdx = idx;
      } else if (name.includes('breite') || name.includes('width')) {
        widthIdx = idx;
      }
    });
    
    if (heightIdx === -1 || lengthIdx === -1 || widthIdx === -1) {
      console.warn('[Ramp Config] Could not find all required option indices', {
        heightIdx, lengthIdx, widthIdx,
        options: options.map(o => o.name)
      });
      return null;
    }
    
    // Convert to strings for comparison (Shopify stores option values as strings)
    const heightStr = String(Math.round(heightCm)); // Round to integer for height
    const lengthStr = String(Math.round(lengthCm)); // Round to integer for length
    const widthStr = String(Math.round(widthCm)); // Round to integer for width
    
    const matchingVariant = variants.find(variant => {
      const vHeight = heightIdx === 0 ? variant.option1 : heightIdx === 1 ? variant.option2 : variant.option3;
      const vLength = lengthIdx === 0 ? variant.option1 : lengthIdx === 1 ? variant.option2 : variant.option3;
      const vWidth = widthIdx === 0 ? variant.option1 : widthIdx === 1 ? variant.option2 : variant.option3;
      
      // Convert variant values to strings for comparison
      const vHeightStr = String(vHeight);
      const vLengthStr = String(vLength);
      const vWidthStr = String(vWidth);
      
      return vHeightStr === heightStr && vLengthStr === lengthStr && vWidthStr === widthStr;
    });
    
    if (!matchingVariant) {
      console.warn('[Ramp Config] No matching variant found', {
        search: { h: heightStr, l: lengthStr, w: widthStr },
        sampleVariant: variants[0] ? {
          option1: variants[0].option1,
          option2: variants[0].option2,
          option3: variants[0].option3
        } : null
      });
    } else {
      // Shopify price is in cents
      const priceCents = matchingVariant.price;
      const priceEur = (priceCents / 100).toFixed(2);
      const compareCents = matchingVariant.compare_at_price || 0;
      const compareEur = compareCents ? (compareCents / 100).toFixed(2) : null;
      console.log('[Ramp Config] Shopify-Variante gefunden', {
        variantId: matchingVariant.id,
        optionen: heightStr + ' / ' + lengthStr + ' / ' + widthStr + ' cm (H/L/B)',
        preisCents: priceCents,
        preisAnzeige: priceEur + ' €',
        vergleichspreisCents: compareCents || '–',
        vergleichspreisAnzeige: compareEur ? compareEur + ' €' : '–'
      });
    }
    
    return matchingVariant;
  }
  
  // Update variant selection in product form
  function updateVariantSelection(variant, productForm, sectionId, options) {
    if (!variant || !productForm) return false;
    
    // Update hidden input with variant ID
    const variantInput = productForm.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.value = variant.id;
    }
    
    // Update product-variants select elements if they exist
    const productVariantsElement = document.querySelector(`product-variants[data-id="${sectionId}"]`);
    if (productVariantsElement) {
      // Find option indices
      let heightIdx = -1;
      let lengthIdx = -1;
      let widthIdx = -1;
      
      options.forEach((option, idx) => {
        const name = option.name.toLowerCase();
        if (name.includes('höhe') || name.includes('height')) {
          heightIdx = idx;
        } else if (name.includes('länge') || name.includes('length')) {
          lengthIdx = idx;
        } else if (name.includes('breite') || name.includes('width')) {
          widthIdx = idx;
        }
      });
      
      if (heightIdx !== -1 && lengthIdx !== -1 && widthIdx !== -1) {
        const variantContainers = productVariantsElement.querySelectorAll('[data-js-product-variant-container]');
        if (variantContainers.length >= 3) {
          const heightValue = heightIdx === 0 ? variant.option1 : heightIdx === 1 ? variant.option2 : variant.option3;
          const lengthValue = lengthIdx === 0 ? variant.option1 : lengthIdx === 1 ? variant.option2 : variant.option3;
          const widthValue = widthIdx === 0 ? variant.option1 : widthIdx === 1 ? variant.option2 : variant.option3;
          
          // Update select values - set value first, then selectedIndex to ensure it's properly selected
          if (variantContainers[heightIdx] && heightValue) {
            const heightStr = String(heightValue);
            variantContainers[heightIdx].value = heightStr;
            // Find and set selectedIndex for select elements
            if (variantContainers[heightIdx].tagName === 'SELECT') {
              const optionIndex = Array.from(variantContainers[heightIdx].options).findIndex(opt => opt.value === heightStr);
              if (optionIndex !== -1) {
                variantContainers[heightIdx].selectedIndex = optionIndex;
              }
            }
          }
          if (variantContainers[lengthIdx] && lengthValue) {
            const lengthStr = String(lengthValue);
            variantContainers[lengthIdx].value = lengthStr;
            if (variantContainers[lengthIdx].tagName === 'SELECT') {
              const optionIndex = Array.from(variantContainers[lengthIdx].options).findIndex(opt => opt.value === lengthStr);
              if (optionIndex !== -1) {
                variantContainers[lengthIdx].selectedIndex = optionIndex;
              }
            }
          }
          if (variantContainers[widthIdx] && widthValue) {
            const widthStr = String(widthValue);
            variantContainers[widthIdx].value = widthStr;
            if (variantContainers[widthIdx].tagName === 'SELECT') {
              const optionIndex = Array.from(variantContainers[widthIdx].options).findIndex(opt => opt.value === widthStr);
              if (optionIndex !== -1) {
                variantContainers[widthIdx].selectedIndex = optionIndex;
              }
            }
          }
          
          // Trigger change events on all selects to ensure the product-variants element updates
          variantContainers.forEach(container => {
            container.dispatchEvent(new Event('change', { bubbles: true }));
          });
          
          // Force update options and master ID before calling onVariantChange
          // This ensures the variant is correctly identified
          if (productVariantsElement.updateOptions) {
            productVariantsElement.updateOptions();
          }
          if (productVariantsElement.updateMasterId) {
            productVariantsElement.updateMasterId();
          }
          
          // Always set currentVariant directly to ensure it's correct
          // Set currentVariant and update price immediately so price display stays in sync
          if (productVariantsElement.getVariantData) {
            const variantData = productVariantsElement.getVariantData();
            const matchingVariant = variantData.find(v => v.id === variant.id);
            if (matchingVariant) {
              productVariantsElement.currentVariant = matchingVariant;
            }
          }
          if (productVariantsElement.onVariantChange) {
            productVariantsElement.onVariantChange();
          }
        } else {
          // If we couldn't find the variant containers, try to set the variant directly
          if (productVariantsElement && productVariantsElement.getVariantData) {
            const variantData = productVariantsElement.getVariantData();
            const matchingVariant = variantData.find(v => v.id === variant.id);
            if (matchingVariant && productVariantsElement.onVariantChange) {
              // Set currentVariant directly
              productVariantsElement.currentVariant = matchingVariant;
              productVariantsElement.onVariantChange();
            }
          }
        }
      }
    }
    
    return true;
  }
  
  // Main mapping function: convert mm to cm, find nearest combo, select variant
  function mapSlidersToVariant(heightCm, lengthCm, widthCm, variants, options, productForm, sectionId) {
    // Values are already in cm
    
    console.log('[Ramp Config] mapSlidersToVariant called', {
      input: { h: heightCm, l: lengthCm, w: widthCm }
    });
    
    // Find nearest valid combination
    const nearestCombo = findNearestCombo(heightCm, lengthCm, widthCm);
    
    if (!nearestCombo) {
      console.error('[Ramp Config] No valid combinations found');
      return {
        success: false,
        error: 'No valid combinations found',
        original: { h: heightCm, l: lengthCm, w: widthCm },
        mapped: null,
        variant: null,
        originalCm: { h: heightCm, l: lengthCm, w: widthCm }
      };
    }
    
    console.log('[Ramp Config] Nearest combo found', nearestCombo);
    
    // Find matching variant (use rounded integer values)
    const variant = findMatchingVariant(
      variants, 
      options, 
      Math.round(nearestCombo.h), 
      Math.round(nearestCombo.l), 
      Math.round(nearestCombo.w)
    );
    
    if (!variant) {
      console.error('[Ramp Config] No matching variant found for combo', nearestCombo);
      return {
        success: false,
        error: 'No matching variant found',
        original: { h: heightCm, l: lengthCm, w: widthCm },
        mapped: nearestCombo,
        variant: null,
        originalCm: { h: heightCm, l: lengthCm, w: widthCm }
      };
    }
    
    // Update variant selection
    const updated = updateVariantSelection(variant, productForm, sectionId, options);
    
    if (!updated) {
      console.error('[Ramp Config] Failed to update variant selection');
    }
    
    return {
      success: updated,
      error: updated ? null : 'Failed to update variant selection',
      original: { h: heightCm, l: lengthCm, w: widthCm },
      mapped: nearestCombo,
      variant: variant,
      originalCm: { h: heightCm, l: lengthCm, w: widthCm }
    };
  }

  // Vollständige Liste der Saugroboter-Modelle nach Hersteller (ab 2018)
  const robotModels = {
    irobot: [
      { name: 'Roomba Max 705 Combo + AutoWash Dock', value: 'roomba-max-705-combo-autowash', year: 2025, maxIncline: 20 },
      { name: 'Roomba Max 705 Vac + AutoEmpty Dock', value: 'roomba-max-705-vac-autoempty', year: 2025, maxIncline: 20 },
      { name: 'Roomba Plus 505 Combo + AutoWash Dock', value: 'roomba-plus-505-combo-autowash', year: 2025, maxIncline: 20 },
      { name: 'Roomba Plus 405 Combo + AutoWash Dock', value: 'roomba-plus-405-combo-autowash', year: 2025, maxIncline: 20 },
      { name: 'Roomba 205 DustCompactor Combo', value: 'roomba-205-dustcompactor-combo', year: 2025, maxIncline: 20 },
      { name: 'Roomba 205 DustCompactor', value: 'roomba-205-dustcompactor', year: 2025, maxIncline: 20 },
      { name: 'Roomba 105', value: 'roomba-105', year: 2025, maxIncline: 20 },
      { name: 'Roomba j9+', value: 'roomba-j9-plus', year: 2024, maxIncline: 20 },
      { name: 'Roomba j9', value: 'roomba-j9', year: 2024, maxIncline: 20 },
      { name: 'Roomba j8+', value: 'roomba-j8-plus', year: 2023, maxIncline: 20 },
      { name: 'Roomba j8', value: 'roomba-j8', year: 2023, maxIncline: 20 },
      { name: 'Roomba j7+', value: 'roomba-j7-plus', year: 2021, maxIncline: 20 },
      { name: 'Roomba j7', value: 'roomba-j7', year: 2021, maxIncline: 20 },
      { name: 'Roomba i7+', value: 'roomba-i7-plus', year: 2019, maxIncline: 18 },
      { name: 'Roomba i7', value: 'roomba-i7', year: 2019, maxIncline: 18 },
      { name: 'Roomba i4+', value: 'roomba-i4-plus', year: 2020, maxIncline: 20 },
      { name: 'Roomba i4', value: 'roomba-i4', year: 2020, maxIncline: 20 },
      { name: 'Roomba i3+', value: 'roomba-i3-plus', year: 2020, maxIncline: 20 },
      { name: 'Roomba i3', value: 'roomba-i3', year: 2020, maxIncline: 20 },
      { name: 'Roomba s9+', value: 'roomba-s9-plus', year: 2019, maxIncline: 20 },
      { name: 'Roomba s9', value: 'roomba-s9', year: 2019, maxIncline: 20 },
      { name: 'Roomba 980', value: 'roomba-980', year: 2015, maxIncline: 15 },
      { name: 'Roomba 960', value: 'roomba-960', year: 2016, maxIncline: 15 },
      { name: 'Roomba 890', value: 'roomba-890', year: 2017, maxIncline: 16 },
      { name: 'Roomba 880', value: 'roomba-880', year: 2014, maxIncline: 15 },
      { name: 'Roomba 870', value: 'roomba-870', year: 2015, maxIncline: 15 },
      { name: 'Roomba 860', value: 'roomba-860', year: 2014, maxIncline: 15 },
      { name: 'Roomba 800', value: 'roomba-800', year: 2013, maxIncline: 15 },
      { name: 'Roomba 690', value: 'roomba-690', year: 2017, maxIncline: 16 },
      { name: 'Roomba 680', value: 'roomba-680', year: 2016, maxIncline: 15 },
      { name: 'Roomba 675', value: 'roomba-675', year: 2018, maxIncline: 18 },
      { name: 'Roomba 671', value: 'roomba-671', year: 2018, maxIncline: 18 },
      { name: 'Roomba 650', value: 'roomba-650', year: 2013, maxIncline: 15 },
      { name: 'Roomba 614', value: 'roomba-614', year: 2018, maxIncline: 18 },
      { name: 'Roomba 692', value: 'roomba-692', year: 2019, maxIncline: 18 },
      { name: 'Roomba e5', value: 'roomba-e5', year: 2018, maxIncline: 18 },
      { name: 'Roomba e6', value: 'roomba-e6', year: 2019, maxIncline: 18 },
      { name: 'Roomba 694', value: 'roomba-694', year: 2020, maxIncline: 20 },
      { name: 'Roomba 895', value: 'roomba-895', year: 2018, maxIncline: 18 },
      { name: 'Roomba 896', value: 'roomba-896', year: 2019, maxIncline: 18 }
    ],
    ecovacs: [
      { name: 'Deebot X8 Pro Omni', value: 'deebot-x8-pro-omni', year: 2025, maxIncline: 22 },
      { name: 'Deebot T50 Max Pro', value: 'deebot-t50-max-pro', year: 2025, maxIncline: 22 },
      { name: 'Deebot T50 Pro Omni', value: 'deebot-t50-pro-omni', year: 2025, maxIncline: 22 },
      { name: 'Deebot X1 Omni', value: 'deebot-x1-omni', year: 2022, maxIncline: 22 },
      { name: 'Deebot X1 Turbo', value: 'deebot-x1-turbo', year: 2022, maxIncline: 22 },
      { name: 'Deebot T20 Omni', value: 'deebot-t20-omni', year: 2023, maxIncline: 22 },
      { name: 'Deebot T10 Omni', value: 'deebot-t10-omni', year: 2022, maxIncline: 20 },
      { name: 'Deebot T9', value: 'deebot-t9', year: 2021, maxIncline: 20 },
      { name: 'Deebot T8 AIVI', value: 'deebot-t8-aivi', year: 2020, maxIncline: 20 },
      { name: 'Deebot T8', value: 'deebot-t8', year: 2020, maxIncline: 20 },
      { name: 'Deebot N10', value: 'deebot-n10', year: 2021, maxIncline: 18 },
      { name: 'Deebot N8 Pro', value: 'deebot-n8-pro', year: 2020, maxIncline: 18 },
      { name: 'Deebot N8', value: 'deebot-n8', year: 2020, maxIncline: 18 },
      { name: 'Deebot N9+', value: 'deebot-n9-plus', year: 2020, maxIncline: 18 },
      { name: 'Deebot N79', value: 'deebot-n79', year: 2019, maxIncline: 18 },
      { name: 'Deebot N79S', value: 'deebot-n79s', year: 2019, maxIncline: 18 },
      { name: 'Deebot N78', value: 'deebot-n78', year: 2019, maxIncline: 18 },
      { name: 'Deebot N77', value: 'deebot-n77', year: 2018, maxIncline: 18 },
      { name: 'Deebot N76', value: 'deebot-n76', year: 2018, maxIncline: 18 },
      { name: 'Deebot N75', value: 'deebot-n75', year: 2018, maxIncline: 18 },
      { name: 'Deebot N74', value: 'deebot-n74', year: 2018, maxIncline: 18 },
      { name: 'Deebot N73', value: 'deebot-n73', year: 2018, maxIncline: 18 },
      { name: 'Deebot 950', value: 'deebot-950', year: 2018, maxIncline: 18 },
      { name: 'Deebot 930', value: 'deebot-930', year: 2017, maxIncline: 15 },
      { name: 'Deebot 920', value: 'deebot-920', year: 2017, maxIncline: 15 },
      { name: 'Deebot 901', value: 'deebot-901', year: 2018, maxIncline: 18 },
      { name: 'Deebot 900', value: 'deebot-900', year: 2017, maxIncline: 15 },
      { name: 'Deebot 711', value: 'deebot-711', year: 2018, maxIncline: 18 },
      { name: 'Deebot 710', value: 'deebot-710', year: 2017, maxIncline: 15 },
      { name: 'Deebot 700', value: 'deebot-700', year: 2016, maxIncline: 15 },
      { name: 'Deebot 601', value: 'deebot-601', year: 2016, maxIncline: 15 },
      { name: 'Deebot 500', value: 'deebot-500', year: 2015, maxIncline: 15 },
      { name: 'Deebot OZMO 950', value: 'deebot-ozmo-950', year: 2019, maxIncline: 18 },
      { name: 'Deebot OZMO 920', value: 'deebot-ozmo-920', year: 2018, maxIncline: 18 },
      { name: 'Deebot OZMO 900', value: 'deebot-ozmo-900', year: 2018, maxIncline: 18 },
      { name: 'Deebot OZMO 610', value: 'deebot-ozmo-610', year: 2018, maxIncline: 18 },
      { name: 'Deebot OZMO 960', value: 'deebot-ozmo-960', year: 2019, maxIncline: 18 },
      { name: 'Deebot OZMO 930', value: 'deebot-ozmo-930', year: 2018, maxIncline: 18 },
      { name: 'Deebot OZMO T8 AIVI', value: 'deebot-ozmo-t8-aivi', year: 2020, maxIncline: 20 },
      { name: 'Deebot OZMO T8', value: 'deebot-ozmo-t8', year: 2020, maxIncline: 20 },
      { name: 'Deebot OZMO T5', value: 'deebot-ozmo-t5', year: 2019, maxIncline: 18 },
      { name: 'Deebot OZMO Slim 10', value: 'deebot-ozmo-slim-10', year: 2020, maxIncline: 18 },
      { name: 'Deebot OZMO Slim 2', value: 'deebot-ozmo-slim-2', year: 2019, maxIncline: 18 },
      { name: 'Deebot OZMO Slim 1', value: 'deebot-ozmo-slim-1', year: 2018, maxIncline: 18 }
    ],
    roborock: [
      { name: 'Roborock Saros Z70', value: 'roborock-saros-z70', year: 2025, maxIncline: 22 },
      { name: 'Roborock Saros 10R', value: 'roborock-saros-10r', year: 2025, maxIncline: 22 },
      { name: 'Roborock Saros 10', value: 'roborock-saros-10', year: 2025, maxIncline: 22 },
      { name: 'Roborock Qrevo Curv 2', value: 'roborock-qrevo-curv-2', year: 2025, maxIncline: 22 },
      { name: 'Roborock S8 Pro Ultra', value: 'roborock-s8-pro-ultra', year: 2024, maxIncline: 22 },
      { name: 'Roborock S8+', value: 'roborock-s8-plus', year: 2024, maxIncline: 22 },
      { name: 'Roborock S8', value: 'roborock-s8', year: 2024, maxIncline: 22 },
      { name: 'Roborock S7 MaxV Ultra', value: 'roborock-s7-maxv-ultra', year: 2022, maxIncline: 22 },
      { name: 'Roborock S7 MaxV', value: 'roborock-s7-maxv', year: 2022, maxIncline: 22 },
      { name: 'Roborock S7+', value: 'roborock-s7-plus', year: 2021, maxIncline: 22 },
      { name: 'Roborock S7', value: 'roborock-s7', year: 2021, maxIncline: 22 },
      { name: 'Roborock S6 MaxV', value: 'roborock-s6-maxv', year: 2020, maxIncline: 20 },
      { name: 'Roborock S6 Pure', value: 'roborock-s6-pure', year: 2020, maxIncline: 20 },
      { name: 'Roborock S6', value: 'roborock-s6', year: 2019, maxIncline: 18 },
      { name: 'Roborock S5 Max', value: 'roborock-s5-max', year: 2020, maxIncline: 20 },
      { name: 'Roborock S5', value: 'roborock-s5', year: 2019, maxIncline: 18 },
      { name: 'Roborock S4 Max', value: 'roborock-s4-max', year: 2020, maxIncline: 15 },
      { name: 'Roborock S4', value: 'roborock-s4', year: 2019, maxIncline: 15 },
      { name: 'Roborock S4 Pure', value: 'roborock-s4-pure', year: 2020, maxIncline: 15 },
      { name: 'Roborock Q7 Max', value: 'roborock-q7-max', year: 2023, maxIncline: 20 },
      { name: 'Roborock Q7', value: 'roborock-q7', year: 2023, maxIncline: 20 },
      { name: 'Roborock Q7+', value: 'roborock-q7-plus', year: 2023, maxIncline: 20 },
      { name: 'Roborock Q5', value: 'roborock-q5', year: 2022, maxIncline: 20 },
      { name: 'Roborock Q5 Pro', value: 'roborock-q5-pro', year: 2022, maxIncline: 20 },
      { name: 'Roborock G10', value: 'roborock-g10', year: 2021, maxIncline: 22 },
      { name: 'Roborock G10S', value: 'roborock-g10s', year: 2022, maxIncline: 22 },
      { name: 'Roborock G10S Pro', value: 'roborock-g10s-pro', year: 2022, maxIncline: 22 },
      { name: 'Roborock E5', value: 'roborock-e5', year: 2021, maxIncline: 20 },
      { name: 'Roborock E4', value: 'roborock-e4', year: 2020, maxIncline: 20 },
      { name: 'Roborock E35', value: 'roborock-e35', year: 2019, maxIncline: 18 },
      { name: 'Roborock E25', value: 'roborock-e25', year: 2019, maxIncline: 18 },
      { name: 'Roborock C10', value: 'roborock-c10', year: 2018, maxIncline: 18 },
      { name: 'Roborock T7 Pro', value: 'roborock-t7-pro', year: 2020, maxIncline: 20 },
      { name: 'Roborock T7', value: 'roborock-t7', year: 2020, maxIncline: 20 },
      { name: 'Roborock T6', value: 'roborock-t6', year: 2019, maxIncline: 18 },
      { name: 'Roborock T4', value: 'roborock-t4', year: 2019, maxIncline: 18 },
      { name: 'Roborock P5', value: 'roborock-p5', year: 2018, maxIncline: 18 },
      { name: 'Roborock V1', value: 'roborock-v1', year: 2018, maxIncline: 18 },
      { name: 'Roborock Xiaowa C10', value: 'roborock-xiaowa-c10', year: 2018, maxIncline: 18 },
      { name: 'Roborock Xiaowa E20', value: 'roborock-xiaowa-e20', year: 2018, maxIncline: 18 },
      { name: 'Roborock Xiaowa E25', value: 'roborock-xiaowa-e25', year: 2018, maxIncline: 18 },
      { name: 'Roborock Xiaowa E35', value: 'roborock-xiaowa-e35', year: 2018, maxIncline: 18 }
    ],
    neato: [
      { name: 'Neato D10', value: 'neato-d10', year: 2022, maxIncline: 18 },
      { name: 'Neato D9', value: 'neato-d9', year: 2021, maxIncline: 18 },
      { name: 'Neato D8', value: 'neato-d8', year: 2020, maxIncline: 18 },
      { name: 'Neato D7', value: 'neato-d7', year: 2019, maxIncline: 16 },
      { name: 'Neato D6', value: 'neato-d6', year: 2018, maxIncline: 16 },
      { name: 'Neato D5', value: 'neato-d5', year: 2018, maxIncline: 16 },
      { name: 'Neato D4', value: 'neato-d4', year: 2018, maxIncline: 16 },
      { name: 'Neato D3', value: 'neato-d3', year: 2018, maxIncline: 16 },
      { name: 'Neato Botvac D85', value: 'neato-botvac-d85', year: 2017, maxIncline: 15 },
      { name: 'Neato Botvac D80', value: 'neato-botvac-d80', year: 2016, maxIncline: 15 },
      { name: 'Neato Botvac D75', value: 'neato-botvac-d75', year: 2016, maxIncline: 15 },
      { name: 'Neato Botvac D70', value: 'neato-botvac-d70', year: 2015, maxIncline: 15 },
      { name: 'Neato Botvac D65', value: 'neato-botvac-d65', year: 2015, maxIncline: 15 },
      { name: 'Neato Botvac D60', value: 'neato-botvac-d60', year: 2014, maxIncline: 15 },
      { name: 'Neato Botvac Connected', value: 'neato-botvac-connected', year: 2016, maxIncline: 15 },
      { name: 'Neato Botvac 85', value: 'neato-botvac-85', year: 2017, maxIncline: 15 },
      { name: 'Neato Botvac 80', value: 'neato-botvac-80', year: 2016, maxIncline: 15 },
      { name: 'Neato Botvac 75', value: 'neato-botvac-75', year: 2016, maxIncline: 15 },
      { name: 'Neato Botvac 70', value: 'neato-botvac-70', year: 2015, maxIncline: 15 },
      { name: 'Neato Botvac 65', value: 'neato-botvac-65', year: 2015, maxIncline: 15 },
      { name: 'Neato Botvac 50', value: 'neato-botvac-50', year: 2014, maxIncline: 15 },
      { name: 'Neato Botvac Signature', value: 'neato-botvac-signature', year: 2013, maxIncline: 15 },
      { name: 'Neato XV-21', value: 'neato-xv-21', year: 2012, maxIncline: 15 },
      { name: 'Neato XV-11', value: 'neato-xv-11', year: 2011, maxIncline: 15 },
      { name: 'Neato XV-12', value: 'neato-xv-12', year: 2012, maxIncline: 15 },
      { name: 'Neato XV-15', value: 'neato-xv-15', year: 2013, maxIncline: 15 }
    ],
    dyson: [
      { name: 'Dyson 360 Vis Nav', value: 'dyson-360-vis-nav', year: 2023, maxIncline: 18 },
      { name: 'Dyson 360 Heurist', value: 'dyson-360-heurist', year: 2020, maxIncline: 18 },
      { name: 'Dyson 360 Eye', value: 'dyson-360-eye', year: 2016, maxIncline: 15 }
    ],
    samsung: [
      { name: 'Samsung Jet Bot AI+', value: 'samsung-jet-bot-ai-plus', year: 2023, maxIncline: 20 },
      { name: 'Samsung Jet Bot', value: 'samsung-jet-bot', year: 2021, maxIncline: 20 },
      { name: 'Samsung Jet Bot Plus', value: 'samsung-jet-bot-plus', year: 2022, maxIncline: 20 },
      { name: 'Samsung Jet Bot Complete', value: 'samsung-jet-bot-complete', year: 2022, maxIncline: 20 },
      { name: 'Samsung POWERbot R9350', value: 'samsung-powerbot-r9350', year: 2019, maxIncline: 18 },
      { name: 'Samsung POWERbot R9250', value: 'samsung-powerbot-r9250', year: 2019, maxIncline: 18 },
      { name: 'Samsung POWERbot R9240', value: 'samsung-powerbot-r9240', year: 2019, maxIncline: 18 },
      { name: 'Samsung POWERbot R9230', value: 'samsung-powerbot-r9230', year: 2019, maxIncline: 18 },
      { name: 'Samsung POWERbot R9220', value: 'samsung-powerbot-r9220', year: 2019, maxIncline: 18 },
      { name: 'Samsung POWERbot R9210', value: 'samsung-powerbot-r9210', year: 2019, maxIncline: 18 },
      { name: 'Samsung POWERbot R9200', value: 'samsung-powerbot-r9200', year: 2019, maxIncline: 18 },
      { name: 'Samsung POWERbot R7070', value: 'samsung-powerbot-r7070', year: 2017, maxIncline: 15 },
      { name: 'Samsung POWERbot R7065', value: 'samsung-powerbot-r7065', year: 2017, maxIncline: 15 },
      { name: 'Samsung POWERbot R7040', value: 'samsung-powerbot-r7040', year: 2017, maxIncline: 15 },
      { name: 'Samsung POWERbot R7030', value: 'samsung-powerbot-r7030', year: 2017, maxIncline: 15 },
      { name: 'Samsung POWERbot R7020', value: 'samsung-powerbot-r7020', year: 2017, maxIncline: 15 },
      { name: 'Samsung POWERbot R7010', value: 'samsung-powerbot-r7010', year: 2017, maxIncline: 15 },
      { name: 'Samsung POWERbot R7000', value: 'samsung-powerbot-r7000', year: 2016, maxIncline: 15 },
      { name: 'Samsung POWERbot R9065', value: 'samsung-powerbot-r9065', year: 2019, maxIncline: 18 },
      { name: 'Samsung POWERbot R9040', value: 'samsung-powerbot-r9040', year: 2019, maxIncline: 18 },
      { name: 'Samsung POWERbot R9030', value: 'samsung-powerbot-r9030', year: 2019, maxIncline: 18 },
      { name: 'Samsung POWERbot R9020', value: 'samsung-powerbot-r9020', year: 2019, maxIncline: 18 },
      { name: 'Samsung POWERbot R9010', value: 'samsung-powerbot-r9010', year: 2019, maxIncline: 18 },
      { name: 'Samsung POWERbot R9000', value: 'samsung-powerbot-r9000', year: 2019, maxIncline: 18 },
      { name: 'Samsung POWERbot R8070', value: 'samsung-powerbot-r8070', year: 2018, maxIncline: 18 },
      { name: 'Samsung POWERbot R8065', value: 'samsung-powerbot-r8065', year: 2018, maxIncline: 18 },
      { name: 'Samsung POWERbot R8040', value: 'samsung-powerbot-r8040', year: 2018, maxIncline: 18 },
      { name: 'Samsung POWERbot R8030', value: 'samsung-powerbot-r8030', year: 2018, maxIncline: 18 },
      { name: 'Samsung POWERbot R8020', value: 'samsung-powerbot-r8020', year: 2018, maxIncline: 18 },
      { name: 'Samsung POWERbot R8010', value: 'samsung-powerbot-r8010', year: 2018, maxIncline: 18 },
      { name: 'Samsung POWERbot R8000', value: 'samsung-powerbot-r8000', year: 2018, maxIncline: 18 },
      { name: 'Samsung POWERbot R7060', value: 'samsung-powerbot-r7060', year: 2017, maxIncline: 15 },
      { name: 'Samsung POWERbot R7050', value: 'samsung-powerbot-r7050', year: 2017, maxIncline: 15 },
      { name: 'Samsung POWERbot R7015', value: 'samsung-powerbot-r7015', year: 2017, maxIncline: 15 },
      { name: 'Samsung POWERbot R7012', value: 'samsung-powerbot-r7012', year: 2017, maxIncline: 15 },
      { name: 'Samsung POWERbot R7011', value: 'samsung-powerbot-r7011', year: 2017, maxIncline: 15 },
      { name: 'Samsung POWERbot R7005', value: 'samsung-powerbot-r7005', year: 2017, maxIncline: 15 },
      { name: 'Samsung POWERbot R7003', value: 'samsung-powerbot-r7003', year: 2017, maxIncline: 15 },
      { name: 'Samsung POWERbot R7002', value: 'samsung-powerbot-r7002', year: 2017, maxIncline: 15 },
      { name: 'Samsung POWERbot R7001', value: 'samsung-powerbot-r7001', year: 2017, maxIncline: 15 }
    ],
    lg: [
      { name: 'LG Hom-Bot Turbo+', value: 'lg-hom-bot-turbo-plus', year: 2020, maxIncline: 18 },
      { name: 'LG Hom-Bot Square', value: 'lg-hom-bot-square', year: 2019, maxIncline: 16 },
      { name: 'LG Hom-Bot Turbo', value: 'lg-hom-bot-turbo', year: 2018, maxIncline: 16 },
      { name: 'LG Hom-Bot 3.0', value: 'lg-hom-bot-3-0', year: 2017, maxIncline: 15 },
      { name: 'LG Hom-Bot 2.0', value: 'lg-hom-bot-2-0', year: 2016, maxIncline: 15 },
      { name: 'LG Hom-Bot 1.0', value: 'lg-hom-bot-1-0', year: 2015, maxIncline: 15 },
      { name: 'LG CordZero A9', value: 'lg-cordzero-a9', year: 2021, maxIncline: 18 },
      { name: 'LG CordZero A8', value: 'lg-cordzero-a8', year: 2020, maxIncline: 18 },
      { name: 'LG CordZero A7', value: 'lg-cordzero-a7', year: 2019, maxIncline: 16 },
      { name: 'LG CordZero A6', value: 'lg-cordzero-a6', year: 2019, maxIncline: 16 },
      { name: 'LG CordZero A5', value: 'lg-cordzero-a5', year: 2018, maxIncline: 16 },
      { name: 'LG CordZero A4', value: 'lg-cordzero-a4', year: 2018, maxIncline: 16 },
      { name: 'LG CordZero A3', value: 'lg-cordzero-a3', year: 2018, maxIncline: 16 },
      { name: 'LG CordZero A2', value: 'lg-cordzero-a2', year: 2018, maxIncline: 16 },
      { name: 'LG CordZero A1', value: 'lg-cordzero-a1', year: 2018, maxIncline: 16 },
      { name: 'LG VR6470LVMB', value: 'lg-vr6470lvmb', year: 2017, maxIncline: 15 },
      { name: 'LG VR6460LVMB', value: 'lg-vr6460lvmb', year: 2017, maxIncline: 15 },
      { name: 'LG VR6450LVMB', value: 'lg-vr6450lvmb', year: 2016, maxIncline: 15 },
      { name: 'LG VR6440LVMB', value: 'lg-vr6440lvmb', year: 2016, maxIncline: 15 },
      { name: 'LG VR6430LVMB', value: 'lg-vr6430lvmb', year: 2016, maxIncline: 15 },
      { name: 'LG VR6420LVMB', value: 'lg-vr6420lvmb', year: 2015, maxIncline: 15 },
      { name: 'LG VR6410LVMB', value: 'lg-vr6410lvmb', year: 2015, maxIncline: 15 },
      { name: 'LG VR6400LVMB', value: 'lg-vr6400lvmb', year: 2015, maxIncline: 15 },
      { name: 'LG VR6390LVMB', value: 'lg-vr6390lvmb', year: 2014, maxIncline: 15 },
      { name: 'LG VR6380LVMB', value: 'lg-vr6380lvmb', year: 2014, maxIncline: 15 },
      { name: 'LG VR6370LVMB', value: 'lg-vr6370lvmb', year: 2014, maxIncline: 15 },
      { name: 'LG VR6360LVMB', value: 'lg-vr6360lvmb', year: 2013, maxIncline: 15 },
      { name: 'LG VR6350LVMB', value: 'lg-vr6350lvmb', year: 2013, maxIncline: 15 },
      { name: 'LG VR6340LVMB', value: 'lg-vr6340lvmb', year: 2013, maxIncline: 15 },
      { name: 'LG VR6330LVMB', value: 'lg-vr6330lvmb', year: 2012, maxIncline: 15 },
      { name: 'LG VR6320LVMB', value: 'lg-vr6320lvmb', year: 2012, maxIncline: 15 },
      { name: 'LG VR6310LVMB', value: 'lg-vr6310lvmb', year: 2012, maxIncline: 15 },
      { name: 'LG VR6300LVMB', value: 'lg-vr6300lvmb', year: 2011, maxIncline: 15 }
    ],
    xiaomi: [
      { name: 'Xiaomi Mi Robot Vacuum Mop Pro', value: 'xiaomi-mi-robot-vacuum-mop-pro', year: 2021, maxIncline: 20 },
      { name: 'Xiaomi Mi Robot Vacuum Mop 2 Pro', value: 'xiaomi-mi-robot-vacuum-mop-2-pro', year: 2022, maxIncline: 20 },
      { name: 'Xiaomi Mi Robot Vacuum Mop 2', value: 'xiaomi-mi-robot-vacuum-mop-2', year: 2021, maxIncline: 20 },
      { name: 'Xiaomi Mi Robot Vacuum Mop', value: 'xiaomi-mi-robot-vacuum-mop', year: 2020, maxIncline: 20 },
      { name: 'Xiaomi Mi Robot Vacuum 1S', value: 'xiaomi-mi-robot-vacuum-1s', year: 2019, maxIncline: 18 },
      { name: 'Xiaomi Mi Robot Vacuum', value: 'xiaomi-mi-robot-vacuum', year: 2016, maxIncline: 15 },
      { name: 'Xiaomi Mi Robot Vacuum 2', value: 'xiaomi-mi-robot-vacuum-2', year: 2018, maxIncline: 18 },
      { name: 'Xiaomi Mi Robot Vacuum 1C', value: 'xiaomi-mi-robot-vacuum-1c', year: 2019, maxIncline: 18 },
      { name: 'Xiaomi Roborock S5', value: 'xiaomi-roborock-s5', year: 2019, maxIncline: 18 },
      { name: 'Xiaomi Roborock S6', value: 'xiaomi-roborock-s6', year: 2019, maxIncline: 18 },
      { name: 'Xiaomi Roborock S50', value: 'xiaomi-roborock-s50', year: 2019, maxIncline: 18 },
      { name: 'Xiaomi Roborock S51', value: 'xiaomi-roborock-s51', year: 2019, maxIncline: 18 },
      { name: 'Xiaomi Roborock S55', value: 'xiaomi-roborock-s55', year: 2019, maxIncline: 18 },
      { name: 'Xiaomi Roborock S6 Pure', value: 'xiaomi-roborock-s6-pure', year: 2020, maxIncline: 20 },
      { name: 'Xiaomi Roborock S5 Max', value: 'xiaomi-roborock-s5-max', year: 2020, maxIncline: 20 },
      { name: 'Xiaomi Roborock S4', value: 'xiaomi-roborock-s4', year: 2019, maxIncline: 15 },
      { name: 'Xiaomi Roborock S4 Max', value: 'xiaomi-roborock-s4-max', year: 2020, maxIncline: 15 },
      { name: 'Xiaomi Roborock T6', value: 'xiaomi-roborock-t6', year: 2019, maxIncline: 18 },
      { name: 'Xiaomi Roborock T7', value: 'xiaomi-roborock-t7', year: 2020, maxIncline: 20 },
      { name: 'Xiaomi Roborock T7 Pro', value: 'xiaomi-roborock-t7-pro', year: 2020, maxIncline: 20 },
      { name: 'Xiaomi Roborock E4', value: 'xiaomi-roborock-e4', year: 2020, maxIncline: 20 },
      { name: 'Xiaomi Roborock E5', value: 'xiaomi-roborock-e5', year: 2021, maxIncline: 20 },
      { name: 'Xiaomi Roborock E35', value: 'xiaomi-roborock-e35', year: 2019, maxIncline: 18 },
      { name: 'Xiaomi Roborock E25', value: 'xiaomi-roborock-e25', year: 2019, maxIncline: 18 },
      { name: 'Xiaomi Roborock C10', value: 'xiaomi-roborock-c10', year: 2018, maxIncline: 18 },
      { name: 'Xiaomi Roborock P5', value: 'xiaomi-roborock-p5', year: 2018, maxIncline: 18 },
      { name: 'Xiaomi Roborock V1', value: 'xiaomi-roborock-v1', year: 2018, maxIncline: 18 },
      { name: 'Xiaomi Roborock Xiaowa C10', value: 'xiaomi-roborock-xiaowa-c10', year: 2018, maxIncline: 18 },
      { name: 'Xiaomi Roborock Xiaowa E20', value: 'xiaomi-roborock-xiaowa-e20', year: 2018, maxIncline: 18 },
      { name: 'Xiaomi Roborock Xiaowa E25', value: 'xiaomi-roborock-xiaowa-e25', year: 2018, maxIncline: 18 },
      { name: 'Xiaomi Roborock Xiaowa E35', value: 'xiaomi-roborock-xiaowa-e35', year: 2018, maxIncline: 18 }
    ],
    eufy: [
      { name: 'Eufy Omni S2', value: 'eufy-omni-s2', year: 2025, maxIncline: 25 },
      { name: 'Eufy Omni E28', value: 'eufy-omni-e28', year: 2025, maxIncline: 20 },
      { name: 'Eufy E25', value: 'eufy-e25', year: 2025, maxIncline: 20 },
      { name: 'Eufy RoboVac G50', value: 'eufy-robovac-g50', year: 2023, maxIncline: 20 },
      { name: 'Eufy RoboVac G40', value: 'eufy-robovac-g40', year: 2022, maxIncline: 20 },
      { name: 'Eufy RoboVac G30', value: 'eufy-robovac-g30', year: 2021, maxIncline: 20 },
      { name: 'Eufy RoboVac G20', value: 'eufy-robovac-g20', year: 2020, maxIncline: 20 },
      { name: 'Eufy RoboVac X8 Hybrid', value: 'eufy-robovac-x8-hybrid', year: 2021, maxIncline: 20 },
      { name: 'Eufy RoboVac X8', value: 'eufy-robovac-x8', year: 2021, maxIncline: 20 },
      { name: 'Eufy RoboVac L70', value: 'eufy-robovac-l70', year: 2020, maxIncline: 20 },
      { name: 'Eufy RoboVac L35', value: 'eufy-robovac-l35', year: 2019, maxIncline: 18 },
      { name: 'Eufy RoboVac 35C', value: 'eufy-robovac-35c', year: 2020, maxIncline: 20 },
      { name: 'Eufy RoboVac 30C', value: 'eufy-robovac-30c', year: 2019, maxIncline: 18 },
      { name: 'Eufy RoboVac 25C', value: 'eufy-robovac-25c', year: 2019, maxIncline: 18 },
      { name: 'Eufy RoboVac 15C', value: 'eufy-robovac-15c', year: 2018, maxIncline: 18 },
      { name: 'Eufy RoboVac 11S', value: 'eufy-robovac-11s', year: 2018, maxIncline: 18 },
      { name: 'Eufy RoboVac 11', value: 'eufy-robovac-11', year: 2018, maxIncline: 18 },
      { name: 'Eufy RoboVac 30', value: 'eufy-robovac-30', year: 2018, maxIncline: 18 },
      { name: 'Eufy RoboVac 15', value: 'eufy-robovac-15', year: 2018, maxIncline: 18 },
      { name: 'Eufy RoboVac 12', value: 'eufy-robovac-12', year: 2018, maxIncline: 18 },
      { name: 'Eufy RoboVac 11S Max', value: 'eufy-robovac-11s-max', year: 2019, maxIncline: 18 },
      { name: 'Eufy RoboVac G10', value: 'eufy-robovac-g10', year: 2020, maxIncline: 20 },
      { name: 'Eufy RoboVac G10 Hybrid', value: 'eufy-robovac-g10-hybrid', year: 2020, maxIncline: 20 },
      { name: 'Eufy RoboVac 30C Max', value: 'eufy-robovac-30c-max', year: 2020, maxIncline: 20 },
      { name: 'Eufy RoboVac 25C Max', value: 'eufy-robovac-25c-max', year: 2020, maxIncline: 20 },
      { name: 'Eufy RoboVac 15C Max', value: 'eufy-robovac-15c-max', year: 2019, maxIncline: 18 },
      { name: 'Eufy RoboVac 30 Max', value: 'eufy-robovac-30-max', year: 2019, maxIncline: 18 },
      { name: 'Eufy RoboVac 11S Pro', value: 'eufy-robovac-11s-pro', year: 2019, maxIncline: 18 },
      { name: 'Eufy RoboVac 11S Hybrid', value: 'eufy-robovac-11s-hybrid', year: 2019, maxIncline: 18 }
    ],
    shark: [
      { name: 'Shark IQ Robot R101AE', value: 'shark-iq-robot-r101ae', year: 2019, maxIncline: 16 },
      { name: 'Shark IQ Robot XL R101AE', value: 'shark-iq-robot-xl-r101ae', year: 2020, maxIncline: 18 },
      { name: 'Shark IQ Robot R100', value: 'shark-iq-robot-r100', year: 2019, maxIncline: 16 },
      { name: 'Shark IQ Robot R100AE', value: 'shark-iq-robot-r100ae', year: 2019, maxIncline: 16 },
      { name: 'Shark ION Robot R75', value: 'shark-ion-robot-r75', year: 2018, maxIncline: 16 },
      { name: 'Shark ION Robot R85', value: 'shark-ion-robot-r85', year: 2018, maxIncline: 16 },
      { name: 'Shark ION Robot R72', value: 'shark-ion-robot-r72', year: 2018, maxIncline: 16 },
      { name: 'Shark ION Robot R70', value: 'shark-ion-robot-r70', year: 2018, maxIncline: 16 },
      { name: 'Shark AI Robot', value: 'shark-ai-robot', year: 2021, maxIncline: 18 },
      { name: 'Shark AI Robot AV2501AE', value: 'shark-ai-robot-av2501ae', year: 2021, maxIncline: 18 },
      { name: 'Shark AV2501AE', value: 'shark-av2501ae', year: 2021, maxIncline: 18 },
      { name: 'Shark AV753', value: 'shark-av753', year: 2020, maxIncline: 18 },
      { name: 'Shark AV752', value: 'shark-av752', year: 2020, maxIncline: 18 },
      { name: 'Shark AV751', value: 'shark-av751', year: 2019, maxIncline: 16 },
      { name: 'Shark AV750', value: 'shark-av750', year: 2019, maxIncline: 16 },
      { name: 'Shark AV701', value: 'shark-av701', year: 2018, maxIncline: 16 },
      { name: 'Shark AV700', value: 'shark-av700', year: 2018, maxIncline: 16 },
      { name: 'Shark AV650', value: 'shark-av650', year: 2017, maxIncline: 15 },
      { name: 'Shark AV600', value: 'shark-av600', year: 2017, maxIncline: 15 },
      { name: 'Shark AV500', value: 'shark-av500', year: 2016, maxIncline: 15 },
      { name: 'Shark AV400', value: 'shark-av400', year: 2016, maxIncline: 15 },
      { name: 'Shark AV300', value: 'shark-av300', year: 2015, maxIncline: 15 },
      { name: 'Shark AV200', value: 'shark-av200', year: 2015, maxIncline: 15 },
      { name: 'Shark AV100', value: 'shark-av100', year: 2014, maxIncline: 15 }
    ],
    miele: [
      { name: 'Miele Scout RX2', value: 'miele-scout-rx2', year: 2020, maxIncline: 18 },
      { name: 'Miele Scout RX1', value: 'miele-scout-rx1', year: 2018, maxIncline: 16 }
    ],
    vorwerk: [
      { name: 'Kobold VR200', value: 'kobold-vr200', year: 2020, maxIncline: 18 },
      { name: 'Kobold VR300', value: 'kobold-vr300', year: 2021, maxIncline: 18 },
      { name: 'Kobold VR7', value: 'kobold-vr7', year: 2017, maxIncline: 15 }
    ],
    dirtdevil: [
      { name: 'Dirt Devil M705', value: 'dirt-devil-m705' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M701', value: 'dirt-devil-m701' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M690', value: 'dirt-devil-m690' , year: 2018, maxIncline: 15}
    ],
    bissell: [
      { name: 'Bissell SpinWave', value: 'bissell-spinwave' , year: 2018, maxIncline: 15},
      { name: 'Bissell AeroSlim', value: 'bissell-aeroslim' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean', value: 'bissell-smartclean' , year: 2018, maxIncline: 15}
    ],
    hoover: [
      { name: 'Hoover Rogue 970', value: 'hoover-rogue-970', year: 2019, maxIncline: 16 },
      { name: 'Hoover Rogue 900', value: 'hoover-rogue-900', year: 2018, maxIncline: 16 },
      { name: 'Hoover Quest 600', value: 'hoover-quest-600', year: 2020, maxIncline: 18 },
      { name: 'Hoover Quest 500', value: 'hoover-quest-500', year: 2019, maxIncline: 16 },
      { name: 'Hoover Quest 400', value: 'hoover-quest-400', year: 2018, maxIncline: 16 },
      { name: 'Hoover Quest 300', value: 'hoover-quest-300', year: 2018, maxIncline: 16 },
      { name: 'Hoover Quest 200', value: 'hoover-quest-200', year: 2018, maxIncline: 16 },
      { name: 'Hoover Quest 100', value: 'hoover-quest-100', year: 2018, maxIncline: 16 },
      { name: 'Hoover React', value: 'hoover-react', year: 2019, maxIncline: 16 },
      { name: 'Hoover Linx', value: 'hoover-linx', year: 2018, maxIncline: 16 },
      { name: 'Hoover Smart', value: 'hoover-smart', year: 2018, maxIncline: 16 },
      { name: 'Hoover Quest 800', value: 'hoover-quest-800', year: 2021, maxIncline: 18 },
      { name: 'Hoover Quest 700', value: 'hoover-quest-700', year: 2020, maxIncline: 18 },
      { name: 'Hoover Quest 650', value: 'hoover-quest-650', year: 2019, maxIncline: 16 },
      { name: 'Hoover Quest 550', value: 'hoover-quest-550', year: 2019, maxIncline: 16 },
      { name: 'Hoover Quest 450', value: 'hoover-quest-450', year: 2018, maxIncline: 16 },
      { name: 'Hoover Quest 350', value: 'hoover-quest-350', year: 2018, maxIncline: 16 },
      { name: 'Hoover Quest 250', value: 'hoover-quest-250', year: 2018, maxIncline: 16 },
      { name: 'Hoover Quest 150', value: 'hoover-quest-150', year: 2018, maxIncline: 16 }
    ],
    kaercher: [
      { name: 'Kärcher RC 4000', value: 'kaercher-rc-4000', year: 2020, maxIncline: 18 },
      { name: 'Kärcher RC 3000', value: 'kaercher-rc-3000', year: 2019, maxIncline: 16 },
      { name: 'Kärcher RCV 3', value: 'kaercher-rcv-3', year: 2018, maxIncline: 16 }
    ],
    philips: [
      { name: 'Philips FC8774', value: 'philips-fc8774', year: 2019, maxIncline: 16 },
      { name: 'Philips FC8776', value: 'philips-fc8776', year: 2020, maxIncline: 18 },
      { name: 'Philips FC8778', value: 'philips-fc8778', year: 2021, maxIncline: 18 }
    ],
    bosch: [
      { name: 'Bosch BSR2', value: 'bosch-bsr2', year: 2020, maxIncline: 18 },
      { name: 'Bosch BSR1', value: 'bosch-bsr1', year: 2019, maxIncline: 16 },
      { name: 'Bosch BGS5', value: 'bosch-bgs5', year: 2018, maxIncline: 16 }
    ],
    siemens: [
      { name: 'Siemens VS07G1223', value: 'siemens-vs07g1223', year: 2020, maxIncline: 18 },
      { name: 'Siemens VS06A1223', value: 'siemens-vs06a1223', year: 2019, maxIncline: 16 }
    ],
    electrolux: [
      { name: 'Electrolux Pure i9', value: 'electrolux-pure-i9', year: 2018, maxIncline: 16 },
      { name: 'Electrolux Pure i9.2', value: 'electrolux-pure-i9-2', year: 2019, maxIncline: 16 },
      { name: 'Electrolux Pure i9.3', value: 'electrolux-pure-i9-3', year: 2020, maxIncline: 18 }
    ],
    dreame: [
      { name: 'Dreame X50 Ultra', value: 'dreame-x50-ultra', year: 2025, maxIncline: 20 },
      { name: 'Dreame Cyber10 Ultra', value: 'dreame-cyber10-ultra', year: 2025, maxIncline: 20 },
      { name: 'Dreame Aqua10 Ultra Roller', value: 'dreame-aqua10-ultra-roller', year: 2025, maxIncline: 20 },
      { name: 'Dreame Aqua10 Roller', value: 'dreame-aqua10-roller', year: 2025, maxIncline: 20 },
      { name: 'Dreame L50 Ultra', value: 'dreame-l50-ultra', year: 2025, maxIncline: 20 },
      { name: 'Dreame L40s Ultra CE', value: 'dreame-l40s-ultra-ce', year: 2025, maxIncline: 20 },
      { name: 'Dreame L40s Ultra AE', value: 'dreame-l40s-ultra-ae', year: 2025, maxIncline: 20 },
      { name: 'Dreame L40s Ultra', value: 'dreame-l40s-ultra', year: 2025, maxIncline: 20 },
      { name: 'Dreame D9', value: 'dreame-d9', year: 2021, maxIncline: 20 },
      { name: 'Dreame D10', value: 'dreame-d10', year: 2022, maxIncline: 20 },
      { name: 'Dreame L10 Pro', value: 'dreame-l10-pro', year: 2021, maxIncline: 20 },
      { name: 'Dreame L10', value: 'dreame-l10', year: 2020, maxIncline: 20 },
      { name: 'Dreame Z10 Pro', value: 'dreame-z10-pro', year: 2021, maxIncline: 20 },
      { name: 'Dreame F9', value: 'dreame-f9', year: 2020, maxIncline: 20 }
    ],
    '360': [
      { name: '360 S7', value: '360-s7', year: 2019, maxIncline: 18 },
      { name: '360 S6', value: '360-s6', year: 2018, maxIncline: 18 },
      { name: '360 S5', value: '360-s5', year: 2018, maxIncline: 18 }
    ],
    eureka: [
      { name: 'Eureka J15 Max Ultra', value: 'eureka-j15-max-ultra', year: 2025, maxIncline: 18 }
    ],
    trifo: [
      { name: 'Trifo Max', value: 'trifo-max', year: 2020, maxIncline: 18 },
      { name: 'Trifo Lucy', value: 'trifo-lucy', year: 2019, maxIncline: 16 },
      { name: 'Trifo Ironpie', value: 'trifo-ironpie', year: 2018, maxIncline: 16 }
    ],
    ilife: [
      { name: 'iLife V5s Pro', value: 'ilife-v5s-pro' , year: 2018, maxIncline: 15},
      { name: 'iLife V5s', value: 'ilife-v5s' , year: 2018, maxIncline: 15},
      { name: 'iLife V5', value: 'ilife-v5' , year: 2018, maxIncline: 15},
      { name: 'iLife V4s', value: 'ilife-v4s' , year: 2018, maxIncline: 15},
      { name: 'iLife V4', value: 'ilife-v4' , year: 2018, maxIncline: 15},
      { name: 'iLife V3s Pro', value: 'ilife-v3s-pro' , year: 2018, maxIncline: 15},
      { name: 'iLife V3s', value: 'ilife-v3s' , year: 2018, maxIncline: 15},
      { name: 'iLife V3', value: 'ilife-v3' , year: 2018, maxIncline: 15},
      { name: 'iLife A9', value: 'ilife-a9' , year: 2018, maxIncline: 15},
      { name: 'iLife A8', value: 'ilife-a8' , year: 2018, maxIncline: 15},
      { name: 'iLife A7', value: 'ilife-a7' , year: 2018, maxIncline: 15},
      { name: 'iLife A6', value: 'ilife-a6' , year: 2018, maxIncline: 15},
      { name: 'iLife A4', value: 'ilife-a4' , year: 2018, maxIncline: 15},
      { name: 'iLife A3', value: 'ilife-a3' , year: 2018, maxIncline: 15},
      { name: 'iLife A2', value: 'ilife-a2' , year: 2018, maxIncline: 15},
      { name: 'iLife A1', value: 'ilife-a1' , year: 2018, maxIncline: 15},
      { name: 'iLife X5', value: 'ilife-x5' , year: 2018, maxIncline: 15},
      { name: 'iLife X800', value: 'ilife-x800' , year: 2018, maxIncline: 15},
      { name: 'iLife X785', value: 'ilife-x785' , year: 2018, maxIncline: 15},
      { name: 'iLife X750', value: 'ilife-x750' , year: 2018, maxIncline: 15},
      { name: 'iLife X650', value: 'ilife-x650' , year: 2018, maxIncline: 15},
      { name: 'iLife X550', value: 'ilife-x550' , year: 2018, maxIncline: 15},
      { name: 'iLife X400', value: 'ilife-x400' , year: 2018, maxIncline: 15},
      { name: 'iLife X300', value: 'ilife-x300' , year: 2018, maxIncline: 15},
      { name: 'iLife X200', value: 'ilife-x200' , year: 2018, maxIncline: 15},
      { name: 'iLife X100', value: 'ilife-x100' , year: 2018, maxIncline: 15},
      { name: 'iLife V8s', value: 'ilife-v8s' , year: 2018, maxIncline: 15},
      { name: 'iLife V8', value: 'ilife-v8' , year: 2018, maxIncline: 15},
      { name: 'iLife V7s Pro', value: 'ilife-v7s-pro' , year: 2018, maxIncline: 15},
      { name: 'iLife V7s', value: 'ilife-v7s' , year: 2018, maxIncline: 15},
      { name: 'iLife V7', value: 'ilife-v7' , year: 2018, maxIncline: 15},
      { name: 'iLife V6', value: 'ilife-v6' , year: 2018, maxIncline: 15}
    ],
    bobsweep: [
      { name: 'bObsweep PetHair', value: 'bobsweep-pethair' , year: 2018, maxIncline: 15},
      { name: 'bObsweep Dustin', value: 'bobsweep-dustin' , year: 2018, maxIncline: 15},
      { name: 'bObsweep PetHair Plus', value: 'bobsweep-pethair-plus' , year: 2018, maxIncline: 15}
    ],
    proscenic: [
      { name: 'Proscenic M7 Pro', value: 'proscenic-m7-pro' , year: 2018, maxIncline: 15},
      { name: 'Proscenic M7', value: 'proscenic-m7' , year: 2018, maxIncline: 15},
      { name: 'Proscenic M6', value: 'proscenic-m6' , year: 2018, maxIncline: 15},
      { name: 'Proscenic M5', value: 'proscenic-m5' , year: 2018, maxIncline: 15},
      { name: 'Proscenic M4', value: 'proscenic-m4' , year: 2018, maxIncline: 15},
      { name: 'Proscenic M3', value: 'proscenic-m3' , year: 2018, maxIncline: 15},
      { name: 'Proscenic M2', value: 'proscenic-m2' , year: 2018, maxIncline: 15},
      { name: 'Proscenic M1', value: 'proscenic-m1' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 850T', value: 'proscenic-850t' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 811GB', value: 'proscenic-811gb' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 810T', value: 'proscenic-810t' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 808C', value: 'proscenic-808c' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 807', value: 'proscenic-807' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 806', value: 'proscenic-806' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 805', value: 'proscenic-805' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 802', value: 'proscenic-802' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 801', value: 'proscenic-801' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 790T', value: 'proscenic-790t' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 780T', value: 'proscenic-780t' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 770T', value: 'proscenic-770t' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 760', value: 'proscenic-760' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 750', value: 'proscenic-750' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 740', value: 'proscenic-740' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 730', value: 'proscenic-730' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 720', value: 'proscenic-720' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 710', value: 'proscenic-710' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 700', value: 'proscenic-700' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 690', value: 'proscenic-690' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 680', value: 'proscenic-680' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 670', value: 'proscenic-670' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 660', value: 'proscenic-660' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 650', value: 'proscenic-650' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 640', value: 'proscenic-640' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 630', value: 'proscenic-630' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 620', value: 'proscenic-620' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 610', value: 'proscenic-610' , year: 2018, maxIncline: 15},
      { name: 'Proscenic 600', value: 'proscenic-600' , year: 2018, maxIncline: 15}
    ],
    yeedi: [
      { name: 'Yeedi Vac 2 Pro', value: 'yeedi-vac-2-pro' , year: 2018, maxIncline: 15},
      { name: 'Yeedi Vac 2', value: 'yeedi-vac-2' , year: 2018, maxIncline: 15},
      { name: 'Yeedi Vac', value: 'yeedi-vac' , year: 2018, maxIncline: 15},
      { name: 'Yeedi K650', value: 'yeedi-k650' , year: 2018, maxIncline: 15},
      { name: 'Yeedi K600', value: 'yeedi-k600' , year: 2018, maxIncline: 15},
      { name: 'Yeedi K580', value: 'yeedi-k580' , year: 2018, maxIncline: 15},
      { name: 'Yeedi K550', value: 'yeedi-k550' , year: 2018, maxIncline: 15},
      { name: 'Yeedi K500', value: 'yeedi-k500' , year: 2018, maxIncline: 15},
      { name: 'Yeedi K450', value: 'yeedi-k450' , year: 2018, maxIncline: 15},
      { name: 'Yeedi K400', value: 'yeedi-k400' , year: 2018, maxIncline: 15},
      { name: 'Yeedi K350', value: 'yeedi-k350' , year: 2018, maxIncline: 15},
      { name: 'Yeedi K300', value: 'yeedi-k300' , year: 2018, maxIncline: 15},
      { name: 'Yeedi K250', value: 'yeedi-k250' , year: 2018, maxIncline: 15},
      { name: 'Yeedi K200', value: 'yeedi-k200' , year: 2018, maxIncline: 15},
      { name: 'Yeedi K150', value: 'yeedi-k150' , year: 2018, maxIncline: 15},
      { name: 'Yeedi K100', value: 'yeedi-k100' , year: 2018, maxIncline: 15},
      { name: 'Yeedi Mop Station', value: 'yeedi-mop-station' , year: 2018, maxIncline: 15},
      { name: 'Yeedi Mop Pro', value: 'yeedi-mop-pro' , year: 2018, maxIncline: 15},
      { name: 'Yeedi Mop', value: 'yeedi-mop' , year: 2018, maxIncline: 15},
      { name: 'Yeedi Vac Station', value: 'yeedi-vac-station' , year: 2018, maxIncline: 15},
      { name: 'Yeedi Vac Pro', value: 'yeedi-vac-pro' , year: 2018, maxIncline: 15},
      { name: 'Yeedi Vac Max', value: 'yeedi-vac-max' , year: 2018, maxIncline: 15},
      { name: 'Yeedi Vac Ultra', value: 'yeedi-vac-ultra' , year: 2018, maxIncline: 15},
      { name: 'Yeedi Vac Elite', value: 'yeedi-vac-elite' , year: 2018, maxIncline: 15},
      { name: 'Yeedi Vac Deluxe', value: 'yeedi-vac-deluxe' , year: 2018, maxIncline: 15},
      { name: 'Yeedi Vac Premium', value: 'yeedi-vac-premium' , year: 2018, maxIncline: 15},
      { name: 'Yeedi Vac Standard', value: 'yeedi-vac-standard' , year: 2018, maxIncline: 15},
      { name: 'Yeedi Vac Basic', value: 'yeedi-vac-basic' , year: 2018, maxIncline: 15},
      { name: 'Yeedi Vac Compact', value: 'yeedi-vac-compact' , year: 2018, maxIncline: 15},
      { name: 'Yeedi Vac Mini', value: 'yeedi-vac-mini' , year: 2018, maxIncline: 15},
      { name: 'Yeedi Vac Micro', value: 'yeedi-vac-micro' , year: 2018, maxIncline: 15}
    ],
    narwal: [
      { name: 'Narwal T10', value: 'narwal-t10' , year: 2018, maxIncline: 15},
      { name: 'Narwal T8', value: 'narwal-t8' , year: 2018, maxIncline: 15},
      { name: 'Narwal T4', value: 'narwal-t4' , year: 2018, maxIncline: 15},
      { name: 'Narwal Freo', value: 'narwal-freo' , year: 2018, maxIncline: 15},
      { name: 'Narwal Freo X1', value: 'narwal-freo-x1' , year: 2018, maxIncline: 15},
      { name: 'Narwal Freo X2', value: 'narwal-freo-x2' , year: 2018, maxIncline: 15},
      { name: 'Narwal Freo X3', value: 'narwal-freo-x3' , year: 2018, maxIncline: 15},
      { name: 'Narwal Freo X4', value: 'narwal-freo-x4' , year: 2018, maxIncline: 15},
      { name: 'Narwal Freo X5', value: 'narwal-freo-x5' , year: 2018, maxIncline: 15},
      { name: 'Narwal Freo X6', value: 'narwal-freo-x6' , year: 2018, maxIncline: 15},
      { name: 'Narwal Freo X7', value: 'narwal-freo-x7' , year: 2018, maxIncline: 15},
      { name: 'Narwal Freo X8', value: 'narwal-freo-x8' , year: 2018, maxIncline: 15},
      { name: 'Narwal Freo X9', value: 'narwal-freo-x9' , year: 2018, maxIncline: 15},
      { name: 'Narwal Freo X10', value: 'narwal-freo-x10' , year: 2018, maxIncline: 15}
    ],
    'irobot-braava': [
      { name: 'Braava jet m6', value: 'braava-jet-m6' , year: 2018, maxIncline: 15},
      { name: 'Braava jet m5', value: 'braava-jet-m5' , year: 2018, maxIncline: 15},
      { name: 'Braava jet m4', value: 'braava-jet-m4' , year: 2018, maxIncline: 15},
      { name: 'Braava jet m3', value: 'braava-jet-m3' , year: 2018, maxIncline: 15},
      { name: 'Braava jet m2', value: 'braava-jet-m2' , year: 2018, maxIncline: 15},
      { name: 'Braava jet m1', value: 'braava-jet-m1' , year: 2018, maxIncline: 15},
      { name: 'Braava 380t', value: 'braava-380t' , year: 2018, maxIncline: 15},
      { name: 'Braava 390t', value: 'braava-390t' , year: 2018, maxIncline: 15},
      { name: 'Braava 320', value: 'braava-320' , year: 2018, maxIncline: 15},
      { name: 'Braava 300', value: 'braava-300' , year: 2018, maxIncline: 15},
      { name: 'Braava 240', value: 'braava-240' , year: 2018, maxIncline: 15},
      { name: 'Braava 200', value: 'braava-200' , year: 2018, maxIncline: 15},
      { name: 'Braava 100', value: 'braava-100' , year: 2018, maxIncline: 15}
    ],
    okp: [
      { name: 'OKP K5', value: 'okp-k5' , year: 2018, maxIncline: 15},
      { name: 'OKP K4', value: 'okp-k4' , year: 2018, maxIncline: 15},
      { name: 'OKP K3', value: 'okp-k3' , year: 2018, maxIncline: 15},
      { name: 'OKP K2', value: 'okp-k2' , year: 2018, maxIncline: 15},
      { name: 'OKP K1', value: 'okp-k1' , year: 2018, maxIncline: 15},
      { name: 'OKP L5', value: 'okp-l5' , year: 2018, maxIncline: 15},
      { name: 'OKP L4', value: 'okp-l4' , year: 2018, maxIncline: 15},
      { name: 'OKP L3', value: 'okp-l3' , year: 2018, maxIncline: 15},
      { name: 'OKP L2', value: 'okp-l2' , year: 2018, maxIncline: 15},
      { name: 'OKP L1', value: 'okp-l1' , year: 2018, maxIncline: 15},
      { name: 'OKP M5', value: 'okp-m5' , year: 2018, maxIncline: 15},
      { name: 'OKP M4', value: 'okp-m4' , year: 2018, maxIncline: 15},
      { name: 'OKP M3', value: 'okp-m3' , year: 2018, maxIncline: 15},
      { name: 'OKP M2', value: 'okp-m2' , year: 2018, maxIncline: 15},
      { name: 'OKP M1', value: 'okp-m1' , year: 2018, maxIncline: 15}
    ],
    genius: [
      { name: 'Genius V5', value: 'genius-v5' , year: 2018, maxIncline: 15},
      { name: 'Genius V4', value: 'genius-v4' , year: 2018, maxIncline: 15},
      { name: 'Genius V3', value: 'genius-v3' , year: 2018, maxIncline: 15},
      { name: 'Genius V2', value: 'genius-v2' , year: 2018, maxIncline: 15},
      { name: 'Genius V1', value: 'genius-v1' , year: 2018, maxIncline: 15},
      { name: 'Genius A5', value: 'genius-a5' , year: 2018, maxIncline: 15},
      { name: 'Genius A4', value: 'genius-a4' , year: 2018, maxIncline: 15},
      { name: 'Genius A3', value: 'genius-a3' , year: 2018, maxIncline: 15},
      { name: 'Genius A2', value: 'genius-a2' , year: 2018, maxIncline: 15},
      { name: 'Genius A1', value: 'genius-a1' , year: 2018, maxIncline: 15}
    ],
    medion: [
      { name: 'Medion MD 18500', value: 'medion-md-18500' , year: 2018, maxIncline: 15},
      { name: 'Medion MD 18400', value: 'medion-md-18400' , year: 2018, maxIncline: 15},
      { name: 'Medion MD 18300', value: 'medion-md-18300' , year: 2018, maxIncline: 15},
      { name: 'Medion MD 18200', value: 'medion-md-18200' , year: 2018, maxIncline: 15},
      { name: 'Medion MD 18100', value: 'medion-md-18100' , year: 2018, maxIncline: 15},
      { name: 'Medion MD 18000', value: 'medion-md-18000' , year: 2018, maxIncline: 15},
      { name: 'Medion MD 17900', value: 'medion-md-17900' , year: 2018, maxIncline: 15},
      { name: 'Medion MD 17800', value: 'medion-md-17800' , year: 2018, maxIncline: 15},
      { name: 'Medion MD 17700', value: 'medion-md-17700' , year: 2018, maxIncline: 15},
      { name: 'Medion MD 17600', value: 'medion-md-17600' , year: 2018, maxIncline: 15},
      { name: 'Medion MD 17500', value: 'medion-md-17500' , year: 2018, maxIncline: 15},
      { name: 'Medion MD 17400', value: 'medion-md-17400' , year: 2018, maxIncline: 15},
      { name: 'Medion MD 17300', value: 'medion-md-17300' , year: 2018, maxIncline: 15},
      { name: 'Medion MD 17200', value: 'medion-md-17200' , year: 2018, maxIncline: 15},
      { name: 'Medion MD 17100', value: 'medion-md-17100' , year: 2018, maxIncline: 15},
      { name: 'Medion MD 17000', value: 'medion-md-17000' , year: 2018, maxIncline: 15}
    ],
    tesvor: [
      { name: 'Tesvor X500', value: 'tesvor-x500' , year: 2018, maxIncline: 15},
      { name: 'Tesvor X400', value: 'tesvor-x400' , year: 2018, maxIncline: 15},
      { name: 'Tesvor X300', value: 'tesvor-x300' , year: 2018, maxIncline: 15},
      { name: 'Tesvor X200', value: 'tesvor-x200' , year: 2018, maxIncline: 15},
      { name: 'Tesvor X100', value: 'tesvor-x100' , year: 2018, maxIncline: 15},
      { name: 'Tesvor S5', value: 'tesvor-s5' , year: 2018, maxIncline: 15},
      { name: 'Tesvor S4', value: 'tesvor-s4' , year: 2018, maxIncline: 15},
      { name: 'Tesvor S3', value: 'tesvor-s3' , year: 2018, maxIncline: 15},
      { name: 'Tesvor S2', value: 'tesvor-s2' , year: 2018, maxIncline: 15},
      { name: 'Tesvor S1', value: 'tesvor-s1' , year: 2018, maxIncline: 15},
      { name: 'Tesvor M5', value: 'tesvor-m5' , year: 2018, maxIncline: 15},
      { name: 'Tesvor M4', value: 'tesvor-m4' , year: 2018, maxIncline: 15},
      { name: 'Tesvor M3', value: 'tesvor-m3' , year: 2018, maxIncline: 15},
      { name: 'Tesvor M2', value: 'tesvor-m2' , year: 2018, maxIncline: 15},
      { name: 'Tesvor M1', value: 'tesvor-m1' , year: 2018, maxIncline: 15}
    ],
    vbot: [
      { name: 'Vbot R95', value: 'vbot-r95' , year: 2018, maxIncline: 15},
      { name: 'Vbot R90', value: 'vbot-r90' , year: 2018, maxIncline: 15},
      { name: 'Vbot R85', value: 'vbot-r85' , year: 2018, maxIncline: 15},
      { name: 'Vbot R80', value: 'vbot-r80' , year: 2018, maxIncline: 15},
      { name: 'Vbot R75', value: 'vbot-r75' , year: 2018, maxIncline: 15},
      { name: 'Vbot R70', value: 'vbot-r70' , year: 2018, maxIncline: 15},
      { name: 'Vbot R65', value: 'vbot-r65' , year: 2018, maxIncline: 15},
      { name: 'Vbot R60', value: 'vbot-r60' , year: 2018, maxIncline: 15},
      { name: 'Vbot R55', value: 'vbot-r55' , year: 2018, maxIncline: 15},
      { name: 'Vbot R50', value: 'vbot-r50' , year: 2018, maxIncline: 15},
      { name: 'Vbot R45', value: 'vbot-r45' , year: 2018, maxIncline: 15},
      { name: 'Vbot R40', value: 'vbot-r40' , year: 2018, maxIncline: 15},
      { name: 'Vbot R35', value: 'vbot-r35' , year: 2018, maxIncline: 15},
      { name: 'Vbot R30', value: 'vbot-r30' , year: 2018, maxIncline: 15},
      { name: 'Vbot R25', value: 'vbot-r25' , year: 2018, maxIncline: 15},
      { name: 'Vbot R20', value: 'vbot-r20' , year: 2018, maxIncline: 15},
      { name: 'Vbot R15', value: 'vbot-r15' , year: 2018, maxIncline: 15},
      { name: 'Vbot R10', value: 'vbot-r10' , year: 2018, maxIncline: 15},
      { name: 'Vbot R5', value: 'vbot-r5' , year: 2018, maxIncline: 15}
    ],
    'dirtdevil': [
      { name: 'Dirt Devil M705', value: 'dirt-devil-m705' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M701', value: 'dirt-devil-m701' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M690', value: 'dirt-devil-m690' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M680', value: 'dirt-devil-m680' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M670', value: 'dirt-devil-m670' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M660', value: 'dirt-devil-m660' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M650', value: 'dirt-devil-m650' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M640', value: 'dirt-devil-m640' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M630', value: 'dirt-devil-m630' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M620', value: 'dirt-devil-m620' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M610', value: 'dirt-devil-m610' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M600', value: 'dirt-devil-m600' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M590', value: 'dirt-devil-m590' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M580', value: 'dirt-devil-m580' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M570', value: 'dirt-devil-m570' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M560', value: 'dirt-devil-m560' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M550', value: 'dirt-devil-m550' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M540', value: 'dirt-devil-m540' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M530', value: 'dirt-devil-m530' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M520', value: 'dirt-devil-m520' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M510', value: 'dirt-devil-m510' , year: 2018, maxIncline: 15},
      { name: 'Dirt Devil M500', value: 'dirt-devil-m500' , year: 2018, maxIncline: 15}
    ],
    'bissell': [
      { name: 'Bissell SpinWave', value: 'bissell-spinwave' , year: 2018, maxIncline: 15},
      { name: 'Bissell AeroSlim', value: 'bissell-aeroslim' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean', value: 'bissell-smartclean' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Pro', value: 'bissell-smartclean-pro' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Max', value: 'bissell-smartclean-max' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Plus', value: 'bissell-smartclean-plus' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Elite', value: 'bissell-smartclean-elite' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Ultra', value: 'bissell-smartclean-ultra' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Deluxe', value: 'bissell-smartclean-deluxe' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Premium', value: 'bissell-smartclean-premium' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Standard', value: 'bissell-smartclean-standard' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Basic', value: 'bissell-smartclean-basic' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Compact', value: 'bissell-smartclean-compact' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Mini', value: 'bissell-smartclean-mini' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Micro', value: 'bissell-smartclean-micro' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Pet', value: 'bissell-smartclean-pet' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Pet Pro', value: 'bissell-smartclean-pet-pro' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Pet Plus', value: 'bissell-smartclean-pet-plus' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Pet Max', value: 'bissell-smartclean-pet-max' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Pet Elite', value: 'bissell-smartclean-pet-elite' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Pet Ultra', value: 'bissell-smartclean-pet-ultra' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Pet Deluxe', value: 'bissell-smartclean-pet-deluxe' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Pet Premium', value: 'bissell-smartclean-pet-premium' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Pet Standard', value: 'bissell-smartclean-pet-standard' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Pet Basic', value: 'bissell-smartclean-pet-basic' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Pet Compact', value: 'bissell-smartclean-pet-compact' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Pet Mini', value: 'bissell-smartclean-pet-mini' , year: 2018, maxIncline: 15},
      { name: 'Bissell SmartClean Pet Micro', value: 'bissell-smartclean-pet-micro' , year: 2018, maxIncline: 15}
    ]
  };

  // Wait for DOM to be ready and import map
  async function initWithImports() {
    // Wait for import map to be available
    if (document.querySelector('script[type="importmap"]')) {
      // Import map is already loaded
      init();
    } else {
      // Wait a bit for import map
      setTimeout(() => {
        init();
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWithImports);
  } else {
    initWithImports();
  }

  function init() {
    const configurators = document.querySelectorAll('.ramp-configurator');
    
    if (configurators.length === 0) {
      return;
    }

    configurators.forEach(configurator => {
      setupConfigurator(configurator);
    });
  }

  function setupConfigurator(configurator) {
    const sectionId = configurator.dataset.sectionId;
    if (!sectionId) {
      console.warn('Ramp configurator missing data-section-id');
      return;
    }

    // Get all control elements
    const manufacturerSelect = configurator.querySelector('[data-ramp-param="robot-manufacturer"]');
    const modelSelect = configurator.querySelector('[data-ramp-param="robot-model"]');
    const heightSlider = configurator.querySelector('[data-ramp-param="height"]');
    const widthSlider = configurator.querySelector('[data-ramp-param="width"]');
    const lengthSlider = configurator.querySelector('[data-ramp-param="length"]');
    const colorPicker = configurator.querySelector('[data-ramp-param="color"]');
    const colorHiddenInput = configurator.querySelector('input[data-ramp-param="color"]');
    const valueDisplays = configurator.querySelectorAll('[data-ramp-value]');
    
    // Get product variants and options for color loading
    const variantsScript = document.querySelector(`script[data-product-variants-json="${sectionId}"]`);
    const optionsScript = document.querySelector(`script[data-product-options-json="${sectionId}"]`);
    const heatmapScript = document.querySelector(`script[data-heatmap-json="${sectionId}"]`);
    let productVariants = [];
    let productOptions = [];
    let heatmap = null;
    
    if (variantsScript) {
      try {
        productVariants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        console.error('Error parsing product variants:', e);
      }
    }
    
    if (optionsScript) {
      try {
        productOptions = JSON.parse(optionsScript.textContent);
      } catch (e) {
        console.error('Error parsing product options:', e);
      }
    }
    
    // Debug: Welche Varianten hat Shopify geladen? (Optionen-Zuordnung + alle Höhen)
    if (productVariants && productVariants.length > 0 && productOptions && productOptions.length >= 3) {
      let heightIdx = -1, lengthIdx = -1, widthIdx = -1;
      productOptions.forEach(function(opt, idx) {
        const n = opt.name.toLowerCase();
        if (n.includes('höhe') || n.includes('height')) heightIdx = idx;
        else if (n.includes('länge') || n.includes('length')) lengthIdx = idx;
        else if (n.includes('breite') || n.includes('width')) widthIdx = idx;
      });
      const getOpt = function(v, idx) { return idx === 0 ? v.option1 : idx === 1 ? v.option2 : v.option3; };
      const heights = [];
      productVariants.forEach(function(v) {
        const h = getOpt(v, heightIdx);
        if (h && heights.indexOf(h) === -1) heights.push(h);
      });
      heights.sort(function(a, b) { return Number(a) - Number(b); });
      console.log('[Ramp Config] Shopify geladen: ' + productVariants.length + ' Varianten | Optionen: ' + (productOptions.map(function(o) { return o.name; }).join(', ')) + ' | Höhen in Varianten: ' + heights.join(', ') + ' | Suche nach "18" möglich: ' + (heights.indexOf('18') !== -1 ? 'JA' : 'NEIN'));
    }
    
    if (heatmapScript) {
      try {
        heatmap = JSON.parse(heatmapScript.textContent);
      } catch (e) {
        console.error('Error parsing heatmap:', e);
      }
    }
    const widthWarning = document.getElementById(`width-warning-${sectionId}`);
    const robotWarning = document.getElementById(`robot-warning-${sectionId}`);
    const robotWarningContent = document.getElementById(`robot-warning-content-${sectionId}`);
    const robotWarningIcon = document.getElementById(`robot-warning-icon-${sectionId}`);
    const mappingStatus = document.getElementById(`mapping-status-${sectionId}`);
    const mappingStatusOriginal = document.getElementById(`mapping-status-original-${sectionId}`);
    const mappingStatusMapped = document.getElementById(`mapping-status-mapped-${sectionId}`);

    if (!heightSlider || !widthSlider || !lengthSlider || !colorPicker || !colorHiddenInput) {
      console.warn('Ramp configurator missing required controls');
      return;
    }

    // Flag to track if length was manually overridden
    let lengthManuallyOverridden = false;
    
    // When no Shopify variant exists for a combo (e.g. 18cm), show price from heatmap if available
    function setPriceFromHeatmapIfAvailable(mappedCombo) {
      if (!mappedCombo || !heatmap || !heatmap.prices) return;
      const h = String(mappedCombo.h);
      const l = String(mappedCombo.l);
      const w = String(mappedCombo.w);
      if (!heatmap.prices[h] || !heatmap.prices[h][l] || heatmap.prices[h][l][w] === undefined) return;
      const priceEl = document.querySelector(`#product-price-${sectionId}`);
      if (!priceEl) return;
      const originalEl = priceEl.querySelector('[data-js-product-price-original]');
      if (!originalEl) return;
      const priceEur = heatmap.prices[h][l][w];
      originalEl.textContent = (typeof priceEur === 'number' ? priceEur : parseFloat(priceEur)).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    }
    
    // Debounce timer for handleChange to prevent too frequent calls
    let handleChangeTimeout = null;
    let configChangeTimeout = null;
    
    // Color mapping: Farbname zu Hex-Code
    const colorMap = {
      'black': '#000000',
      'schwarz': '#000000',
      'white': '#ffffff',
      'weiß': '#ffffff',
      'grey': '#808080',
      'gray': '#808080',
      'grau': '#808080',
      'brown': '#8b4513',
      'braun': '#8b4513',
      'red': '#ff0000',
      'rot': '#ff0000',
      'blue': '#0000ff',
      'blau': '#0000ff',
      'green': '#008000',
      'grün': '#008000',
      'yellow': '#ffff00',
      'gelb': '#ffff00',
      'orange': '#ffa500',
      'purple': '#800080',
      'lila': '#800080',
      'pink': '#ffc0cb',
      'rosa': '#ffc0cb'
    };
    
    // Funktion zum Normalisieren von Farbnamen (lowercase, ohne Leerzeichen)
    function normalizeColorName(colorName) {
      if (!colorName) return '';
      return colorName.toLowerCase().trim().replace(/\s+/g, '');
    }
    
    // Localize color name for display
    function getLocalizedColorName(colorName) {
      if (!colorName) return '';
      const normalized = normalizeColorName(colorName);
      
      // Color name mapping (English -> German)
      const colorTranslations = {
        'black': 'Schwarz',
        'schwarz': 'Schwarz',
        'white': 'Weiß',
        'weiß': 'Weiß',
        'grey': 'Grau',
        'gray': 'Grau',
        'grau': 'Grau',
        'brown': 'Braun',
        'braun': 'Braun',
        'red': 'Rot',
        'rot': 'Rot',
        'blue': 'Blau',
        'blau': 'Blau',
        'green': 'Grün',
        'grün': 'Grün',
        'yellow': 'Gelb',
        'gelb': 'Gelb',
        'orange': 'Orange',
        'pink': 'Rosa',
        'rosa': 'Rosa',
        'purple': 'Lila',
        'lila': 'Lila'
      };
      
      // Return translated name if available, otherwise capitalize first letter
      if (colorTranslations[normalized]) {
        return colorTranslations[normalized];
      }
      
      // Fallback: capitalize first letter
      return colorName.charAt(0).toUpperCase() + colorName.slice(1).toLowerCase();
    }
    
    // Funktion zum Finden der Farb-Option in den Produkt-Optionen
    function findColorOptionIndex(options) {
      const colorKeywords = ['color', 'colour', 'farbe', 'couleur'];
      for (let i = 0; i < options.length; i++) {
        const optionName = options[i].name.toLowerCase();
        if (colorKeywords.some(keyword => optionName.includes(keyword))) {
          return i; // Gibt 0, 1 oder 2 zurück (option1, option2, option3)
        }
      }
      return -1; // Keine Farb-Option gefunden
    }
    
    // Funktion zum Extrahieren der Hex-Farbe aus einem Farbnamen
    function getColorHex(colorName) {
      const normalized = normalizeColorName(colorName);
      // Direktes Mapping
      if (colorMap[normalized]) {
        return colorMap[normalized];
      }
      // Suche nach Teilübereinstimmungen
      for (const [key, hex] of Object.entries(colorMap)) {
        if (normalized.includes(key) || key.includes(normalized)) {
          return hex;
        }
      }
      // Fallback: Versuche Hex-Code direkt zu parsen
      if (normalized.match(/^#[0-9a-f]{6}$/i)) {
        return normalized;
      }
      // Letzter Fallback: Grau
      return '#808080';
    }
    
    // Funktion zum Laden der Farben aus den Varianten
    function loadColorsFromVariants() {
      if (!colorPicker || productVariants.length === 0) {
        // Fallback: Standard-Farben verwenden
        loadDefaultColors();
        return;
      }
      
      // Finde die Farb-Option
      const colorOptionIndex = findColorOptionIndex(productOptions);
      if (colorOptionIndex === -1) {
        console.log('Keine Farb-Option in den Produkt-Optionen gefunden. Verwende Standard-Farben.');
        loadDefaultColors();
        return;
      }
      
      // Sammle eindeutige Farben aus den Varianten
      const colorMap = new Map(); // colorName -> { variantId, hex, name }
      
      productVariants.forEach(variant => {
        let colorValue = '';
        if (colorOptionIndex === 0 && variant.option1) {
          colorValue = variant.option1;
        } else if (colorOptionIndex === 1 && variant.option2) {
          colorValue = variant.option2;
        } else if (colorOptionIndex === 2 && variant.option3) {
          colorValue = variant.option3;
        }
        
        if (colorValue) {
          const normalized = normalizeColorName(colorValue);
          if (!colorMap.has(normalized)) {
            colorMap.set(normalized, {
              variantId: variant.id,
              hex: getColorHex(colorValue),
              name: colorValue,
              value: normalized
            });
          }
        }
      });
      
      // Leere den Color-Picker
      colorPicker.innerHTML = '';
      
      // Erstelle Color-Buttons für jede gefundene Farbe
      const colors = Array.from(colorMap.values());
      if (colors.length === 0) {
        loadDefaultColors();
        return;
      }
      
      // Sortiere Farben (Schwarz zuerst, dann alphabetisch)
      colors.sort((a, b) => {
        if (a.value === 'black' || a.value === 'schwarz') return -1;
        if (b.value === 'black' || b.value === 'schwarz') return 1;
        return a.name.localeCompare(b.name);
      });
      
      colors.forEach((color, index) => {
        const isActive = index === 0; // Erste Farbe ist aktiv
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ramp-configurator__color-option' + (isActive ? ' ramp-configurator__color-option--active' : '');
        button.setAttribute('data-color-value', color.value);
        button.setAttribute('data-color-name', color.name);
        button.setAttribute('data-variant-id', color.variantId);
        button.setAttribute('aria-label', `Select ${color.name} color`);
        
        const bgColor = color.hex;
        const borderStyle = (color.value === 'white' || color.value === 'weiß') 
          ? 'border: 1px solid rgba(0, 0, 0, 0.2);' 
          : '';
        button.setAttribute('style', `background-color: ${bgColor}; ${borderStyle}`);
        
        const check = document.createElement('span');
        check.className = 'ramp-configurator__color-option-check';
        check.textContent = '✓';
        button.appendChild(check);
        
        colorPicker.appendChild(button);
      });
      
      // Setze die erste Farbe als Standard
      if (colors.length > 0 && colorHiddenInput) {
        colorHiddenInput.value = colors[0].value;
        
        // Setze auch die Varianten-ID im Formular
        if (colors[0].variantId && productForm) {
          const variantInput = productForm.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.value = colors[0].variantId;
          }
        }
      }
      
      // Attach event listeners to new color options
      const colorOptions = colorPicker.querySelectorAll('.ramp-configurator__color-option');
      colorOptions.forEach(option => {
        option.addEventListener('click', handleColorSelect);
      });
      
      console.log('Farben aus Varianten geladen:', colors);
    }
    
    // Funktion zum Laden der Standard-Farben (Fallback)
    function loadDefaultColors() {
      const defaultColors = [
        { value: 'grey', name: 'Grey', hex: '#808080' },
        { value: 'black', name: 'Black', hex: '#000000' },
        { value: 'brown', name: 'Brown', hex: '#8b4513' },
        { value: 'white', name: 'White', hex: '#ffffff' }
      ];
      
      colorPicker.innerHTML = '';
      
      defaultColors.forEach((color, index) => {
        const isActive = index === 1; // Schwarz ist Standard
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ramp-configurator__color-option' + (isActive ? ' ramp-configurator__color-option--active' : '');
        button.setAttribute('data-color-value', color.value);
        button.setAttribute('data-color-name', color.name);
        button.setAttribute('aria-label', `Select ${color.name} color`);
        
        const bgColor = color.hex;
        const borderStyle = (color.value === 'white') 
          ? 'border: 1px solid rgba(0, 0, 0, 0.2);' 
          : '';
        button.setAttribute('style', `background-color: ${bgColor}; ${borderStyle}`);
        
        const check = document.createElement('span');
        check.className = 'ramp-configurator__color-option-check';
        check.textContent = '✓';
        button.appendChild(check);
        
        colorPicker.appendChild(button);
      });
      
      if (colorHiddenInput) {
        colorHiddenInput.value = 'black';
      }
      
      // Attach event listeners
      const colorOptions = colorPicker.querySelectorAll('.ramp-configurator__color-option');
      colorOptions.forEach(option => {
        option.addEventListener('click', handleColorSelect);
      });
    }

    // Handle robot manufacturer selection
    function handleManufacturerChange() {
      const manufacturer = manufacturerSelect.value;
      
      // Clear model select - use localized text
      const selectModelText = configurator.dataset.i18nSelectModel || 'Modell wählen...';
      modelSelect.innerHTML = `<option value="">${selectModelText}</option>`;
      modelSelect.disabled = true;
      
      if (manufacturer && robotModels[manufacturer]) {
        // Sammle Jahre für Modelle mit gleichem Namen
        const modelYearsMap = {};
        robotModels[manufacturer].forEach(model => {
          const modelName = model.name;
          const year = model.year || estimateYearFromModel(model.name, manufacturer);
          if (!modelYearsMap[modelName]) {
            modelYearsMap[modelName] = [];
          }
          if (!modelYearsMap[modelName].includes(year)) {
            modelYearsMap[modelName].push(year);
          }
        });
        
        // Populate model select with manufacturer's models
        robotModels[manufacturer].forEach(model => {
          const option = document.createElement('option');
          option.value = model.value;
          const modelName = model.name;
          const years = modelYearsMap[modelName] || [];
          
          // Bestimme das Jahr-Format: Einzeljahr oder Bereich
          let yearDisplay = '';
          if (years.length > 0) {
            years.sort((a, b) => a - b); // Sortiere Jahre aufsteigend
            if (years.length === 1) {
              yearDisplay = `(${years[0]})`;
            } else {
              // Mehrere Jahre: zeige Bereich vom ersten bis zum letzten Jahr
              yearDisplay = `(${years[0]}-${years[years.length - 1]})`;
            }
          }
          
          const displayName = yearDisplay ? `${modelName} ${yearDisplay}` : modelName;
          option.textContent = displayName;
          modelSelect.appendChild(option);
        });
        modelSelect.disabled = false;
      }
    }
    
    // Hilfsfunktion zum Schätzen des Baujahrs basierend auf Modellname
    function estimateYearFromModel(modelName, manufacturer) {
      // Extrahiere Zahlen aus dem Modellnamen
      const numbers = modelName.match(/\d+/g);
      if (!numbers || numbers.length === 0) {
        return 2018; // Standard für Modelle ohne Zahlen
      }
      
      // Versuche das Jahr aus der Modellnummer zu schätzen
      const lastNumber = parseInt(numbers[numbers.length - 1]);
      
      // Für verschiedene Hersteller unterschiedliche Logik
      if (manufacturer === 'samsung' && lastNumber >= 7000) {
        // Samsung POWERbot: R7000 = 2016, R8000 = 2018, R9000 = 2019
        if (lastNumber >= 9000) return 2019;
        if (lastNumber >= 8000) return 2018;
        if (lastNumber >= 7000) return 2016;
      }
      
      if (manufacturer === 'lg' && lastNumber >= 6300) {
        // LG VR: 6300 = 2011, 6400 = 2015, etc.
        if (lastNumber >= 6470) return 2017;
        if (lastNumber >= 6400) return 2015;
        return 2011;
      }
      
      // Standard-Schätzung basierend auf Modellnummer
      if (lastNumber >= 900) return 2020;
      if (lastNumber >= 800) return 2019;
      if (lastNumber >= 700) return 2018;
      if (lastNumber >= 600) return 2017;
      if (lastNumber >= 500) return 2016;
      if (lastNumber >= 400) return 2015;
      if (lastNumber >= 300) return 2014;
      if (lastNumber >= 200) return 2013;
      if (lastNumber >= 100) return 2012;
      
      return 2018; // Fallback
    }

    // Get the product form for this section
    const productForm = document.querySelector(`#product-form-${sectionId}`);
    if (!productForm) {
      console.warn(`Product form not found for section ${sectionId}`);
    }

    // Get max incline for a robot model
    function getMaxIncline(manufacturer, modelValue) {
      if (!manufacturer || !modelValue || !robotModels[manufacturer]) {
        return 20; // Default: 20 Grad
      }
      
      const model = robotModels[manufacturer].find(m => m.value === modelValue);
      if (model && model.maxIncline !== undefined) {
        return model.maxIncline;
      }
      
      // Schätzung basierend auf Jahr und Hersteller
      const year = model ? (model.year || estimateYearFromModel(model.name, manufacturer)) : 2018;
      
      // Neuere Modelle (2020+) haben meist bessere Steigfähigkeit
      if (year >= 2020) {
        // Premium-Modelle (S9, S8, X1, etc.) haben oft 25 Grad
        if (modelValue.includes('s9') || modelValue.includes('s8') || 
            modelValue.includes('x1') || modelValue.includes('max') || 
            modelValue.includes('pro') || modelValue.includes('ultra')) {
          return 25;
        }
        return 22; // Standard neuere Modelle
      } else if (year >= 2018) {
        return 20; // Modelle 2018-2019
      } else {
        return 15; // Ältere Modelle
      }
    }

    // Round value to nearest allowed value in array
    function roundToNearestAllowed(value, allowedValues) {
      if (!allowedValues || allowedValues.length === 0) return value;
      return allowedValues.reduce((prev, curr) => {
        return Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev;
      });
    }

    // Round height, length, width to allowed values from heatmap
    function roundToHeatmapValues(heightCm, lengthCm, widthCm) {
      if (!heatmap || !heatmap.options) {
        return { height: heightCm, length: lengthCm, width: widthCm, available: false };
      }

      const opts = heatmap.options;
      
      // Round height to nearest allowed value
      const roundedHeight = roundToNearestAllowed(heightCm, opts.height_cm);
      
      // Get allowed lengths for this height
      const allowedLengths = opts.length_cm_by_height[String(roundedHeight)];
      if (!allowedLengths || allowedLengths.length === 0) {
        return { height: roundedHeight, length: lengthCm, width: widthCm, available: false };
      }
      
      // Round length to nearest allowed value for this height
      const roundedLength = roundToNearestAllowed(lengthCm, allowedLengths);
      
      // Round width to nearest allowed value
      const roundedWidth = roundToNearestAllowed(widthCm, opts.width_cm);
      
      // Check if combination exists in heatmap prices
      const available = checkHeatmapAvailability(roundedHeight, roundedLength, roundedWidth);
      
      return {
        height: roundedHeight,
        length: roundedLength,
        width: roundedWidth,
        available: available
      };
    }

    // Check if combination exists in heatmap
    function checkHeatmapAvailability(heightCm, lengthCm, widthCm) {
      if (!heatmap || !heatmap.prices) return false;
      
      const heightStr = String(heightCm);
      const lengthStr = String(lengthCm);
      const widthStr = String(widthCm);
      
      if (!heatmap.prices[heightStr]) return false;
      if (!heatmap.prices[heightStr][lengthStr]) return false;
      if (heatmap.prices[heightStr][lengthStr][widthStr] === undefined) return false;
      
      return true;
    }

    // Find matching Shopify variant by option values
    function findMatchingVariant(heightCm, lengthCm, widthCm) {
      if (!productVariants || productVariants.length === 0) return null;
      if (!productOptions || productOptions.length !== 3) return null;
      
      // Find option indices (assuming order: height_cm, length_cm, width_cm)
      let heightIndex = -1;
      let lengthIndex = -1;
      let widthIndex = -1;
      
      productOptions.forEach((option, index) => {
        const optionName = option.name.toLowerCase();
        if (optionName.includes('height') || optionName.includes('höhe')) {
          heightIndex = index;
        } else if (optionName.includes('length') || optionName.includes('länge')) {
          lengthIndex = index;
        } else if (optionName.includes('width') || optionName.includes('breite')) {
          widthIndex = index;
        }
      });
      
      if (heightIndex === -1 || lengthIndex === -1 || widthIndex === -1) {
        console.warn('Could not find all required option indices');
        return null;
      }
      
      // Find variant matching the rounded values
      const heightStr = String(heightCm);
      const lengthStr = String(lengthCm);
      const widthStr = String(widthCm);
      
      return productVariants.find(variant => {
        const variantHeight = heightIndex === 0 ? variant.option1 : heightIndex === 1 ? variant.option2 : variant.option3;
        const variantLength = lengthIndex === 0 ? variant.option1 : lengthIndex === 1 ? variant.option2 : variant.option3;
        const variantWidth = widthIndex === 0 ? variant.option1 : widthIndex === 1 ? variant.option2 : variant.option3;
        
        return variantHeight === heightStr && variantLength === lengthStr && variantWidth === widthStr;
      });
    }

    // Update variant selection in product form
    function updateVariantSelection(variant) {
      if (!variant || !productForm) return false;
      
      // Update hidden input with variant ID
      const variantInput = productForm.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = variant.id;
      }
      
      // Update product-variants select elements if they exist
      const productVariantsElement = document.querySelector(`product-variants[data-id="${sectionId}"]`);
      if (productVariantsElement) {
        // Find option indices
        let heightIndex = -1;
        let lengthIndex = -1;
        let widthIndex = -1;
        
        productOptions.forEach((option, index) => {
          const optionName = option.name.toLowerCase();
          if (optionName.includes('height') || optionName.includes('höhe')) {
            heightIndex = index;
          } else if (optionName.includes('length') || optionName.includes('länge')) {
            lengthIndex = index;
          } else if (optionName.includes('width') || optionName.includes('breite')) {
            widthIndex = index;
          }
        });
        
        if (heightIndex !== -1 && lengthIndex !== -1 && widthIndex !== -1) {
          const variantContainers = productVariantsElement.querySelectorAll('[data-js-product-variant-container]');
          if (variantContainers.length >= 3) {
            const heightValue = heightIndex === 0 ? variant.option1 : heightIndex === 1 ? variant.option2 : variant.option3;
            const lengthValue = lengthIndex === 0 ? variant.option1 : lengthIndex === 1 ? variant.option2 : variant.option3;
            const widthValue = widthIndex === 0 ? variant.option1 : widthIndex === 1 ? variant.option2 : variant.option3;
            
            // Update select values - set value first, then selectedIndex to ensure it's properly selected
            if (variantContainers[heightIndex] && heightValue) {
              const heightStr = String(heightValue);
              variantContainers[heightIndex].value = heightStr;
              // Find and set selectedIndex for select elements
              if (variantContainers[heightIndex].tagName === 'SELECT') {
                const optionIndex = Array.from(variantContainers[heightIndex].options).findIndex(opt => opt.value === heightStr);
                if (optionIndex !== -1) {
                  variantContainers[heightIndex].selectedIndex = optionIndex;
                }
              }
            }
            if (variantContainers[lengthIndex] && lengthValue) {
              const lengthStr = String(lengthValue);
              variantContainers[lengthIndex].value = lengthStr;
              if (variantContainers[lengthIndex].tagName === 'SELECT') {
                const optionIndex = Array.from(variantContainers[lengthIndex].options).findIndex(opt => opt.value === lengthStr);
                if (optionIndex !== -1) {
                  variantContainers[lengthIndex].selectedIndex = optionIndex;
                }
              }
            }
            if (variantContainers[widthIndex] && widthValue) {
              const widthStr = String(widthValue);
              variantContainers[widthIndex].value = widthStr;
              if (variantContainers[widthIndex].tagName === 'SELECT') {
                const optionIndex = Array.from(variantContainers[widthIndex].options).findIndex(opt => opt.value === widthStr);
                if (optionIndex !== -1) {
                  variantContainers[widthIndex].selectedIndex = optionIndex;
                }
              }
            }
            
            // Trigger change events on all selects to ensure the product-variants element updates
            variantContainers.forEach(container => {
              container.dispatchEvent(new Event('change', { bubbles: true }));
            });
            
            // Force update options and master ID before calling onVariantChange
            // This ensures the variant is correctly identified
            if (productVariantsElement.updateOptions) {
              productVariantsElement.updateOptions();
            }
            if (productVariantsElement.updateMasterId) {
              productVariantsElement.updateMasterId();
            }
            
            // Always set currentVariant directly to ensure it's correct
            if (productVariantsElement.getVariantData) {
              const variantData = productVariantsElement.getVariantData();
              const matchingVariant = variantData.find(v => v.id === variant.id);
              if (matchingVariant) {
                productVariantsElement.currentVariant = matchingVariant;
              }
            }
            
            // Use requestAnimationFrame to ensure DOM updates are processed
            requestAnimationFrame(() => {
              // Double-check that currentVariant is set
              if (!productVariantsElement.currentVariant && productVariantsElement.getVariantData) {
                const variantData = productVariantsElement.getVariantData();
                const matchingVariant = variantData.find(v => v.id === variant.id);
                if (matchingVariant) {
                  productVariantsElement.currentVariant = matchingVariant;
                }
              }
              
              // Now trigger onVariantChange to update price and other elements
              if (productVariantsElement.onVariantChange) {
                productVariantsElement.onVariantChange();
              }
            });
          } else {
            // If we couldn't find the variant containers, try to set the variant directly
            if (productVariantsElement && productVariantsElement.getVariantData) {
              const variantData = productVariantsElement.getVariantData();
              const matchingVariant = variantData.find(v => v.id === variant.id);
              if (matchingVariant && productVariantsElement.onVariantChange) {
                // Set currentVariant directly
                productVariantsElement.currentVariant = matchingVariant;
                productVariantsElement.onVariantChange();
              }
            }
          }
        }
      }
      
      return true;
    }

    // Update variant status display
    function updateVariantStatus(rounded, original) {
      if (!variantStatus || !variantStatusValue) return;
      
      if (!rounded.available) {
        variantStatus.style.display = 'block';
        variantStatus.classList.add('ramp-configurator__variant-status--unavailable');
        const notAvailableText = configurator.dataset.i18nNotAvailable || configurator.getAttribute('data-i18n-not-available') || 'Nicht verfügbar';
        variantStatusValue.textContent = notAvailableText;
        return;
      }
      
      variantStatus.style.display = 'block';
      variantStatus.classList.remove('ramp-configurator__variant-status--unavailable');
      variantStatusValue.textContent = `${rounded.height}/${rounded.length}/${rounded.width} cm`;
    }

    // Calculate optimal length based on height and max incline
    // Die Steigung wird auf 0,5° aufgerundet, und die Länge wird entsprechend angepasst
    // Die Länge wird so berechnet, dass die tatsächliche Steigung (nach Aufrunden) unter maxIncline bleibt
    function calculateOptimalLength(height, maxInclineDeg) {
      if (!height || !maxInclineDeg || maxInclineDeg <= 0) {
        return null;
      }
      
      // Runde die Steigung auf 0,5° auf (z.B. 18,3° → 18,5°, 18,7° → 19,0°)
      const roundedIncline = Math.ceil(maxInclineDeg * 2) / 2;
      
      // Berechne die minimale Länge basierend auf der aufgerundeten Steigung
      // Länge = Höhe / tan(aufgerundete_Steigung in Grad)
      const roundedInclineRad = roundedIncline * (Math.PI / 180);
      const minLength = height / Math.tan(roundedInclineRad);
      
      // Runde auf die nächsthöhere längere Länge (aufrunden)
      // Dies stellt sicher, dass die tatsächliche Steigung nach dem Aufrunden unter maxIncline bleibt
      let optimalLength = Math.ceil(minLength);
      
      // Prüfe, ob die tatsächliche Steigung bei dieser Länge noch zu steil ist
      // Wenn ja, erhöhe die Länge weiter
      while (optimalLength <= 60) {
        const actualInclineRad = Math.atan(height / optimalLength);
        const actualInclineDeg = (actualInclineRad * 180) / Math.PI;
        const actualInclineRounded = Math.ceil(actualInclineDeg * 2) / 2;
        
        // Wenn die aufgerundete Steigung <= maxIncline ist, haben wir die richtige Länge
        if (actualInclineRounded <= maxInclineDeg) {
          break;
        }
        
        // Sonst erhöhe die Länge um 1 cm
        optimalLength += 1;
      }
      
      // Ensure minimum length (15cm) and maximum length (60cm)
      return Math.max(15, Math.min(60, optimalLength));
    }

    // Auto-calculate length if robot and height are set
    function autoCalculateLength() {
      const manufacturer = manufacturerSelect.value;
      const model = modelSelect.value;
      const heightCm = parseFloat(heightSlider.value); // cm
      
      // Only auto-calculate if robot is selected and length wasn't manually overridden
      if (manufacturer && model && heightCm && !lengthManuallyOverridden) {
        const maxIncline = getMaxIncline(manufacturer, model);
        const optimalLengthCm = calculateOptimalLength(heightCm, maxIncline);
        
        if (optimalLengthCm !== null) {
          // Round to nearest 5cm step
          const roundedLength = Math.round(optimalLengthCm / 5) * 5;
          lengthSlider.value = roundedLength; // cm
          // Stelle sicher, dass die Anzeige sofort aktualisiert wird
          const lengthDisplay = Array.from(valueDisplays).find(d => d.dataset.rampValue === 'length');
          if (lengthDisplay) {
            lengthDisplay.textContent = roundedLength + ' cm';
          }
        }
      }
    }

    // Check width and show warning if < 45cm
    function checkWidthWarning() {
      const widthCm = parseFloat(widthSlider.value);
      if (widthWarning) {
        if (widthCm < 45) {
          widthWarning.style.display = 'block';
        } else {
          widthWarning.style.display = 'none';
        }
      }
    }

    // Get current configuration (values in mm)
    function getCurrentConfig() {
      // Get color hex from active color button
      let colorHex = '#000000'; // Default black
      const activeColorButton = colorPicker.querySelector('.ramp-configurator__color-option--active');
      if (activeColorButton) {
        const style = activeColorButton.getAttribute('style');
        if (style) {
          const match = style.match(/background-color:\s*([^;]+)/);
          if (match) {
            colorHex = match[1].trim();
          }
        }
      }
      
      // Slider values are now in cm
      const heightCm = parseFloat(heightSlider.value, 10) || 3;
      const widthCm = parseInt(widthSlider.value, 10) || 45;
      const lengthCm = parseInt(lengthSlider.value, 10) || 15;
      
      return {
        height: heightCm, // cm for 3D viewer
        width: widthCm,   // cm for 3D viewer
        length: lengthCm, // cm for 3D viewer
        heightCm: heightCm,
        widthCm: widthCm,
        lengthCm: lengthCm,
        heightMm: Math.round(heightCm * 10), // Convert to mm for properties
        widthMm: widthCm * 10,   // Convert to mm for properties
        lengthMm: lengthCm * 10, // Convert to mm for properties
        color: colorHiddenInput.value || 'black',
        colorHex: colorHex, // Hex-Farbe für 3D-Viewer
        robotManufacturer: manufacturerSelect.value || '',
        robotModel: modelSelect.value || '',
        maxIncline: getMaxIncline(manufacturerSelect.value, modelSelect.value)
      };
    }
    
    // Handle color selection
    function handleColorSelect(event) {
      const colorOption = event.currentTarget;
      const colorValue = colorOption.dataset.colorValue;
      const variantId = colorOption.dataset.variantId;
      
      // Remove active class from all color options
      const allColorOptions = colorPicker.querySelectorAll('.ramp-configurator__color-option');
      allColorOptions.forEach(option => {
        option.classList.remove('ramp-configurator__color-option--active');
      });
      
      // Add active class to selected option
      colorOption.classList.add('ramp-configurator__color-option--active');
      
      // Update hidden input
      colorHiddenInput.value = colorValue;
      
      // Update variant ID in product form if variant ID is available
      if (variantId && productForm) {
        const variantInput = productForm.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.value = variantId;
        }
      }
      
      // Trigger change event
      handleChange();
    }

    // Update value displays (now in cm)
    function updateValueDisplays() {
      valueDisplays.forEach(display => {
        const param = display.dataset.rampValue;
        let value;
        
        if (param === 'height') {
          value = parseFloat(heightSlider.value, 10); // cm, with decimals
          display.textContent = value.toFixed(1) + ' cm';
        } else if (param === 'width') {
          value = parseInt(widthSlider.value, 10); // cm, no decimals
          display.textContent = value + ' cm';
        } else if (param === 'length') {
          value = parseInt(lengthSlider.value, 10); // cm, no decimals
          display.textContent = value + ' cm';
        }
      });
    }

    // Dispatch configuration change event
    function dispatchConfigChange(config) {
      const event = new CustomEvent('rw:config-change', {
        detail: {
          sectionId: sectionId,
          config: config
        },
        bubbles: true
      });
      document.dispatchEvent(event);
    }

    // Inject properties into form
    function injectFormProperties(config) {
      if (!productForm) return;

      // Get localized property names from data attributes
      const propertyHeight = configurator.dataset.i18nPropertyHeight || 'Height';
      const propertyWidth = configurator.dataset.i18nPropertyWidth || 'Width';
      const propertyLength = configurator.dataset.i18nPropertyLength || 'Length';
      const propertyColor = configurator.dataset.i18nPropertyColor || 'Color';

      // Remove existing property inputs (check for both localized and English names)
      const existingProps = productForm.querySelectorAll('[name^="properties["]');
      existingProps.forEach(input => {
        const name = input.name.toLowerCase();
        if (name.includes('height') || name.includes('höhe') ||
            name.includes('width') || name.includes('breite') ||
            name.includes('length') || name.includes('länge') ||
            name.includes('color') || name.includes('farbe') ||
            name.includes('robot') ||
            name.includes('konfig-key') || name.includes('konfig_key')) {
          input.remove();
        }
      });

      // Store values in cm for cart display
      const heightCm = config.heightCm.toFixed(1) + ' cm';
      const widthCm = config.widthCm + ' cm';
      const lengthCm = config.lengthCm + ' cm';
      
      // Create config key for reference (using cm values)
      const configKey = `H${Math.round(config.heightCm * 10)}_L${config.lengthCm}_B${config.widthCm}`;

      // Create and inject new property inputs with localized names
      // Store values in cm for cart display
      
      // Localize color name
      const localizedColor = getLocalizedColorName(config.color);
      
      const properties = [
        { name: `properties[${propertyHeight}]`, value: heightCm },
        { name: `properties[${propertyLength}]`, value: lengthCm },
        { name: `properties[${propertyWidth}]`, value: widthCm },
        { name: `properties[Konfig-Key]`, value: configKey },
        { name: `properties[${propertyColor}]`, value: localizedColor }
      ];

      // Add robot properties if selected (with localized names)
      if (config.robotManufacturer && config.robotModel) {
        const manufacturerSelect = configurator.querySelector('[data-ramp-param="robot-manufacturer"]');
        const modelSelect = configurator.querySelector('[data-ramp-param="robot-model"]');
        
        // Get localized property names
        const propertyRobotManufacturer = configurator.dataset.i18nPropertyRobotManufacturer || 'Robot Manufacturer';
        const propertyRobotModel = configurator.dataset.i18nPropertyRobotModel || 'Robot Model';
        
        if (manufacturerSelect && modelSelect) {
          const manufacturerOption = manufacturerSelect.options[manufacturerSelect.selectedIndex];
          const modelOption = modelSelect.options[modelSelect.selectedIndex];
          
          if (manufacturerOption && manufacturerOption.text) {
            properties.push({ name: `properties[${propertyRobotManufacturer}]`, value: manufacturerOption.text });
          }
          if (modelOption && modelOption.text) {
            properties.push({ name: `properties[${propertyRobotModel}]`, value: modelOption.text });
          }
        }
      }

      properties.forEach(prop => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = prop.name;
        input.value = prop.value;
        productForm.appendChild(input);
      });
    }

    // Calculate incline in degrees, rounded up to nearest 0.5 degree
    function calculateIncline(height, length) {
      if (!length || length === 0) return 0;
      const inclineRad = Math.atan(height / length);
      const inclineDeg = (inclineRad * 180) / Math.PI;
      return Math.ceil(inclineDeg * 2) / 2; // Runden auf die nächste 0,5 Grad
    }

    function getAddToCartButton() {
      return productForm?.querySelector('[data-js-product-add-to-cart], button[type="submit"], input[type="submit"]') || null;
    }

    function getAddToCartTextEl(button) {
      if (!button || button.tagName === 'INPUT') return null;
      return button.querySelector('[data-js-product-add-to-cart-text]') || null;
    }

    function getButtonLabel(button) {
      if (!button) return '';
      if (button.tagName === 'INPUT') return String(button.value || '').trim();
      const textEl = getAddToCartTextEl(button);
      if (textEl) return String(textEl.textContent || '').trim();
      return String(button.textContent || '').trim();
    }

    function setButtonLabel(button, label) {
      if (!button) return;
      if (button.tagName === 'INPUT') {
        button.value = label;
      } else {
        const textEl = getAddToCartTextEl(button);
        if (textEl) {
          textEl.textContent = label;
        } else if (button.setAttribute) {
          // Don't overwrite the whole button markup (icons/preloader). If the label span is missing,
          // only provide an accessibility fallback.
          button.setAttribute('aria-label', label);
        }
      }
    }

    function setAddToCartButtonState({ disabled, forceLabel } = {}) {
      const button = getAddToCartButton();
      if (!button) return;

      // Cache original label once
      if (!button.dataset.rwOriginalLabel) {
        const current = getButtonLabel(button);
        if (current) button.dataset.rwOriginalLabel = current;
      }

      if (typeof disabled === 'boolean') {
        button.disabled = disabled;
        if (disabled) button.classList.add('disabled');
        else button.classList.remove('disabled');
      }

      if (typeof forceLabel === 'string') {
        setButtonLabel(button, forceLabel);
        // Make disabled label readable (theme may fade disabled buttons too much)
        if (forceLabel.toLowerCase().includes('nicht bestellbar')) {
          button.classList.add('rw-not-orderable');
        } else {
          button.classList.remove('rw-not-orderable');
        }
      } else if (!disabled && button.dataset.rwOriginalLabel) {
        // Restore default label when orderable again
        setButtonLabel(button, button.dataset.rwOriginalLabel);
        button.classList.remove('rw-not-orderable');
      } else if (disabled) {
        // Disabled for other reasons (e.g., variant unavailable) should not force our styling
        button.classList.remove('rw-not-orderable');
      }
    }

    function updateAddToCartOrderability({ variantAvailable } = {}) {
      const manufacturer = manufacturerSelect.value;
      const model = modelSelect.value;
      const hasRobot = Boolean(manufacturer && model);

      const height = parseFloat(heightSlider.value) || 3; // cm
      const length = parseFloat(lengthSlider.value) || 15; // cm
      const incline = calculateIncline(height, length);

      // Base state: mapping / variant availability
      const baseDisabled = variantAvailable === false;

      // Rule A: No robot selected, incline > 17° => not orderable
      const noRobotTooSteep = !hasRobot && incline > 17;

      // Rule B: Robot selected + current config triggers "Rampe sollte mindestens..." (= incline too steep for that robot)
      let robotTooSteep = false;
      if (hasRobot) {
        let maxIncline = 15;
        const robotMaxIncline = getMaxIncline(manufacturer, model);
        if (robotMaxIncline !== null && robotMaxIncline !== undefined) {
          maxIncline = robotMaxIncline;
        }
        robotTooSteep = incline > maxIncline;
      }

      const notOrderable = noRobotTooSteep || robotTooSteep;

      if (notOrderable) {
        // Theme may overwrite label during VARIANT_CHANGE; enforce twice (now + next frame)
        setAddToCartButtonState({ disabled: true, forceLabel: 'Nicht bestellbar' });
        requestAnimationFrame(() => {
          setAddToCartButtonState({ disabled: true, forceLabel: 'Nicht bestellbar' });
        });
        return;
      }

      // If variant is not available, keep disabled (and don't force label)
      setAddToCartButtonState({ disabled: baseDisabled });
    }

    // Re-apply orderability after theme variant updates (price/button label updates happen there)
    const productVariantsElementForOrderability = document.querySelector(`product-variants[data-id="${sectionId}"]`);
    let lastVariantAvailableForOrderability = true;
    if (productVariantsElementForOrderability) {
      productVariantsElementForOrderability.addEventListener('VARIANT_CHANGE', () => {
        requestAnimationFrame(() => {
          updateAddToCartOrderability({ variantAvailable: lastVariantAvailableForOrderability });
        });
      });
    }

    // Update robot compatibility warning
    function updateRobotWarning() {
      if (!robotWarning || !robotWarningContent) return;

      const manufacturer = manufacturerSelect.value;
      const model = modelSelect.value;
      const height = parseFloat(heightSlider.value) || 3; // cm
      const length = parseFloat(lengthSlider.value) || 15; // cm

      // Calculate incline
      const incline = calculateIncline(height, length);
      
      // Determine max incline:
      // - If robot is selected: use robot's max incline from database (if available), otherwise use 15
      // - If no robot is selected: always use 15 degrees as threshold
      let maxIncline = 15; // Default: 15 Grad (wenn kein Roboter gewählt)
      if (manufacturer && model) {
        const robotMaxIncline = getMaxIncline(manufacturer, model);
        // Use robot's max incline if available (not null), otherwise keep 15
        if (robotMaxIncline !== null && robotMaxIncline !== undefined) {
          maxIncline = robotMaxIncline;
        }
      }

      // Always show warning if incline > maxIncline (regardless of robot selection)
      // This includes the case when no robot is selected and incline > 18
      if (incline > maxIncline) {
        robotWarning.style.display = 'block';
      } else if (manufacturer && model) {
        // Show OK message only if robot is selected and incline is OK
        robotWarning.style.display = 'block';
      } else {
        // Hide warning if incline is OK and no robot is selected
        robotWarning.style.display = 'none';
        return;
      }

      // Update warning content and styling
      robotWarning.className = 'ramp-configurator__robot-warning';

      if (incline <= maxIncline) {
        // Only show OK message if robot is selected
        if (manufacturer && model) {
          robotWarning.classList.add('ramp-configurator__robot-warning--ok');
          // Check Icon für OK
          if (robotWarningIcon) {
            robotWarningIcon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" preserveAspectRatio="xMidYMid meet" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" /></svg>';
          }
          robotWarningContent.textContent = 'Rampe ist für diesen Saugroboter geeignet';
        }
      } else {
        robotWarning.classList.add('ramp-configurator__robot-warning--error');
        // ExclamationTriangle Icon für Warnung
        if (robotWarningIcon) {
          robotWarningIcon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" preserveAspectRatio="xMidYMid meet" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" /></svg>';
        }
        // Calculate required length
        const roundedIncline = Math.ceil(maxIncline * 2) / 2;
        const roundedInclineRad = roundedIncline * (Math.PI / 180);
        const minLength = height / Math.tan(roundedInclineRad);
        let requiredLength = Math.ceil(minLength);

        // Iterative check
        while (requiredLength <= 60) {
          const actualInclineRad = Math.atan(height / requiredLength);
          const actualInclineDeg = (actualInclineRad * 180) / Math.PI;
          const actualInclineRounded = Math.ceil(actualInclineDeg * 2) / 2;

          if (actualInclineRounded <= maxIncline) {
            break;
          }
          requiredLength += 1;
        }

        // Different message if no robot is selected
        if (manufacturer && model) {
          robotWarningContent.textContent = configurator.dataset.i18nRobotError || `Rampe sollte mindestens ${requiredLength} cm lang sein`;
        } else {
          // Use localized message for general incline warning
          const inclineWarningText = configurator.dataset.i18nInclineWarningGeneral || 
            `Die Steigung beträgt ${incline.toFixed(1)}°. Für die meisten Saugroboter sollte die Steigung nicht mehr als 18° betragen. Rampe sollte mindestens ${requiredLength} cm lang sein`;
          robotWarningContent.textContent = inclineWarningText
            .replace('{{ incline }}', incline.toFixed(1))
            .replace('{{ length }}', requiredLength);
        }
      }
    }

    // Handle control changes (with debouncing to prevent too frequent calls)
    function handleChange() {
      // Clear existing timeout
      if (handleChangeTimeout) {
        clearTimeout(handleChangeTimeout);
      }
      
      // Debounce: wait 50ms before executing (reduced for better responsiveness)
      handleChangeTimeout = setTimeout(() => {
        handleChangeImmediate();
      }, 50);
    }
    
    // Dispatch config change with throttling for 3D viewer (60fps = ~16ms)
    function dispatchConfigChangeThrottled(config) {
      // Clear existing timeout
      if (configChangeTimeout) {
        clearTimeout(configChangeTimeout);
      }
      
      // Throttle to ~60fps (16ms) for smooth 3D updates
      configChangeTimeout = setTimeout(() => {
        dispatchConfigChange(config);
      }, 16);
    }
    
    // Immediate change handler (called after debounce)
    function handleChangeImmediate() {
      const config = getCurrentConfig();
      let variantAvailable = true;
      
      // Map sliders (cm) to variant using CSV-based mapping
      if (productVariants && productOptions && productOptions.length >= 3) {
        try {
          const mappingResult = mapSlidersToVariant(
            config.heightCm,
            config.lengthCm,
            config.widthCm,
            productVariants,
            productOptions,
            productForm,
            sectionId
          );
          
          // Update mapping status display
          if (mappingStatus && mappingStatusOriginal && mappingStatusMapped) {
            if (mappingResult.success && mappingResult.mapped) {
              mappingStatus.style.display = 'block';
              mappingStatus.classList.remove('ramp-configurator__mapping-status--error');
              // Show original values in cm (with one decimal for height)
              const origH = mappingResult.originalCm ? mappingResult.originalCm.h : mappingResult.original.h;
              const origL = mappingResult.originalCm ? mappingResult.originalCm.l : mappingResult.original.l;
              const origW = mappingResult.originalCm ? mappingResult.originalCm.w : mappingResult.original.w;
              mappingStatusOriginal.textContent = `${origH.toFixed(1)} / ${origL} / ${origW} cm`;
              mappingStatusMapped.textContent = `${mappingResult.mapped.h} / ${mappingResult.mapped.l} / ${mappingResult.mapped.w} cm`;
              
              // Console: welcher Preis von Shopify für die gewählte Variante geladen wurde
              if (mappingResult.variant) {
                const v = mappingResult.variant;
                const priceEur = (v.price / 100).toFixed(2);
                const compareEur = v.compare_at_price && v.compare_at_price > v.price ? (v.compare_at_price / 100).toFixed(2) : null;
                console.log('[Ramp Config] Preis von Shopify geladen | Variante-ID: ' + v.id + ' | H/L/B: ' + v.option1 + ' / ' + v.option2 + ' / ' + v.option3 + ' cm | Preis: ' + v.price + ' Cent (' + priceEur + ' €)' + (compareEur ? ' | Vergleichspreis: ' + compareEur + ' €' : ''));
              }
              
              // Enable add to cart button
              const addToCartButton = productForm?.querySelector('button[type="submit"], input[type="submit"]');
              if (addToCartButton) {
                addToCartButton.disabled = false;
                addToCartButton.classList.remove('disabled');
              }
            } else {
              variantAvailable = false;
              mappingStatus.style.display = 'block';
              mappingStatus.classList.add('ramp-configurator__mapping-status--error');
              // Show original values in cm
              mappingStatusOriginal.textContent = `${config.heightCm.toFixed(1)} / ${config.lengthCm} / ${config.widthCm} cm`;
              mappingStatusMapped.textContent = configurator.dataset.i18nNotAvailable || 'Nicht verfügbar';
              
              // Console: keine Shopify-Variante für diese Kombination
              if (mappingResult.mapped) {
                console.log('[Ramp Config] Keine Shopify-Variante gefunden | Gewählte Kombination: H/L/B ' + mappingResult.mapped.h + ' / ' + mappingResult.mapped.l + ' / ' + mappingResult.mapped.w + ' cm – Preis wird aus Heatmap angezeigt.');
                setPriceFromHeatmapIfAvailable(mappingResult.mapped);
              }
              
              // Disable add to cart button
              const addToCartButton = productForm?.querySelector('button[type="submit"], input[type="submit"]');
              if (addToCartButton) {
                addToCartButton.disabled = true;
                addToCartButton.classList.add('disabled');
              }
            }
          }
        } catch (error) {
          console.error('Error mapping to variant:', error);
        }
      }
      
      // updateValueDisplays() is already called immediately in handler functions
      checkWidthWarning(); // Check width warning (convert mm to cm for check)
      updateRobotWarning(); // Update robot compatibility warning
      lastVariantAvailableForOrderability = variantAvailable;
      updateAddToCartOrderability({ variantAvailable }); // Apply "Nicht bestellbar" rules
      dispatchConfigChangeThrottled(config); // Throttled for smooth 3D updates
      injectFormProperties(config);
    }

    // Handle height change - auto-calculate length if robot is selected
    function handleHeightChange() {
      autoCalculateLength();
      updateValueDisplays(); // Update display immediately for smooth slider movement
      handleChange();
    }

    // Handle robot model change - auto-calculate length if height is set
    function handleRobotModelChange() {
      // Reset manual override when robot changes - wichtig: vor autoCalculateLength()
      lengthManuallyOverridden = false;
      // Berechne die neue Länge basierend auf dem neuen Roboter
      autoCalculateLength();
      // Aktualisiere alle Anzeigen (inkl. Länge)
      updateValueDisplays();
      // Trigger change event für 3D-Viewer und Form
      handleChange();
    }

    // Handle length change - mark as manually overridden
    function handleLengthChange() {
      lengthManuallyOverridden = true; // Mark as manually overridden
      updateValueDisplays(); // Update display immediately
      handleChange();
    }

    // Handle width change - update display immediately
    function handleWidthChange() {
      updateValueDisplays(); // Update display immediately
      checkWidthWarning(); // Check width warning immediately
      handleChange();
    }

    // Attach event listeners
    if (manufacturerSelect) {
      manufacturerSelect.addEventListener('change', () => {
        handleManufacturerChange();
        lengthManuallyOverridden = false; // Reset when manufacturer changes
        autoCalculateLength();
        updateValueDisplays(); // Stelle sicher, dass die Länge-Anzeige aktualisiert wird
        handleChange();
      });
    }
    
    if (modelSelect) {
      modelSelect.addEventListener('change', handleRobotModelChange);
    }
    
    heightSlider.addEventListener('input', handleHeightChange);
    widthSlider.addEventListener('input', handleWidthChange);
    lengthSlider.addEventListener('input', handleLengthChange);
    
    // Load colors from variants (or use defaults)
    loadColorsFromVariants();

    // Initial update
    updateValueDisplays();
    checkWidthWarning(); // Check initial width
    autoCalculateLength(); // Try to auto-calculate length on initial load
    const initialConfig = getCurrentConfig();
    updateRobotWarning();
    updateAddToCartOrderability({ variantAvailable: true });
    
    // Map initial slider values to variant and update price
    // Use setTimeout to ensure product-variants element is fully initialized
    setTimeout(() => {
      if (productVariants && productOptions && productOptions.length >= 3) {
        try {
          const mappingResult = mapSlidersToVariant(
            initialConfig.heightCm,
            initialConfig.lengthCm,
            initialConfig.widthCm,
            productVariants,
            productOptions,
            productForm,
            sectionId
          );
          
          // Update mapping status display
          if (mappingStatus && mappingStatusOriginal && mappingStatusMapped) {
            if (mappingResult.success && mappingResult.mapped) {
              mappingStatus.style.display = 'block';
              mappingStatus.classList.remove('ramp-configurator__mapping-status--error');
              // Show original values in cm (with one decimal for height)
              const origH = mappingResult.originalCm ? mappingResult.originalCm.h : mappingResult.original.h;
              const origL = mappingResult.originalCm ? mappingResult.originalCm.l : mappingResult.original.l;
              const origW = mappingResult.originalCm ? mappingResult.originalCm.w : mappingResult.original.w;
              mappingStatusOriginal.textContent = `${origH.toFixed(1)} / ${origL} / ${origW} cm`;
              mappingStatusMapped.textContent = `${mappingResult.mapped.h} / ${mappingResult.mapped.l} / ${mappingResult.mapped.w} cm`;
              
              // Console: welcher Preis von Shopify für die gewählte Variante geladen wurde (Initial)
              if (mappingResult.variant) {
                const v = mappingResult.variant;
                const priceEur = (v.price / 100).toFixed(2);
                const compareEur = v.compare_at_price && v.compare_at_price > v.price ? (v.compare_at_price / 100).toFixed(2) : null;
                console.log('[Ramp Config] Preis von Shopify geladen (Initial) | Variante-ID: ' + v.id + ' | H/L/B: ' + v.option1 + ' / ' + v.option2 + ' / ' + v.option3 + ' cm | Preis: ' + v.price + ' Cent (' + priceEur + ' €)' + (compareEur ? ' | Vergleichspreis: ' + compareEur + ' €' : ''));
              }
              
              // Enable add to cart button
              const addToCartButton = productForm?.querySelector('button[type="submit"], input[type="submit"]');
              if (addToCartButton) {
                addToCartButton.disabled = false;
                addToCartButton.classList.remove('disabled');
              }
              updateAddToCartOrderability({ variantAvailable: true });
            } else {
              mappingStatus.style.display = 'block';
              mappingStatus.classList.add('ramp-configurator__mapping-status--error');
              // Show original values in cm
              mappingStatusOriginal.textContent = `${initialConfig.heightCm.toFixed(1)} / ${initialConfig.lengthCm} / ${initialConfig.widthCm} cm`;
              mappingStatusMapped.textContent = configurator.dataset.i18nNotAvailable || 'Nicht verfügbar';
              
              // Console: keine Shopify-Variante für diese Kombination (Initial)
              if (mappingResult.mapped) {
                console.log('[Ramp Config] Keine Shopify-Variante gefunden (Initial) | H/L/B ' + mappingResult.mapped.h + ' / ' + mappingResult.mapped.l + ' / ' + mappingResult.mapped.w + ' cm – Preis aus Heatmap.');
                setPriceFromHeatmapIfAvailable(mappingResult.mapped);
              }
              
              // Disable add to cart button
              const addToCartButton = productForm?.querySelector('button[type="submit"], input[type="submit"]');
              if (addToCartButton) {
                addToCartButton.disabled = true;
                addToCartButton.classList.add('disabled');
              }
              updateAddToCartOrderability({ variantAvailable: false });
            }
          }
        } catch (error) {
          console.error('Error mapping initial variant:', error);
        }
      }
    }, 100); // Small delay to ensure product-variants element is ready
    
    dispatchConfigChange(initialConfig);
    injectFormProperties(initialConfig);
    
    // Fix thumbnail navigation for ramp gallery
    setTimeout(function() {
      const productPage = document.querySelector('product-page#product-' + sectionId);
      if (!productPage || !productPage.productSlider) {
        console.log('[Ramp Gallery] Product page or slider not found, retrying...');
        setTimeout(arguments.callee, 200);
        return;
      }
      
      const thumbnails = productPage.querySelectorAll('.product-gallery__thumbnails .thumbnail');
      if (thumbnails.length === 0) {
        console.log('[Ramp Gallery] No thumbnails found, retrying...');
        setTimeout(arguments.callee, 200);
        return;
      }
      
      console.log('[Ramp Gallery] Found', thumbnails.length, 'thumbnails');
      
      // Get all gallery items to verify indices
      const galleryItems = productPage.productGallery.querySelectorAll('.product-gallery__item');
      console.log('[Ramp Gallery] Found', galleryItems.length, 'gallery items');
      galleryItems.forEach(function(item, i) {
        console.log('[Ramp Gallery] Item', i, 'has data-index:', item.dataset.index);
      });
      
      // Override thumbnail click handlers
      thumbnails.forEach(function(thumbnail, thumbIndex) {
        const dataIndex = thumbnail.dataset.index;
        console.log('[Ramp Gallery] Thumbnail', thumbIndex, 'has data-index:', dataIndex);
        
        // Clone to remove existing listeners
        const newThumbnail = thumbnail.cloneNode(true);
        thumbnail.parentNode.replaceChild(newThumbnail, thumbnail);
        
        // Add click listener
        newThumbnail.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const targetIndex = parseInt(dataIndex, 10);
          console.log('[Ramp Gallery] Thumbnail clicked, target index:', targetIndex);
          
          // Find the gallery item with matching data-index
          const targetItem = Array.from(galleryItems).find(function(item) {
            return parseInt(item.dataset.index, 10) === targetIndex;
          });
          
          if (!targetItem) {
            console.error('[Ramp Gallery] Target item not found for index:', targetIndex);
            return;
          }
          
          // Find the array index of the target item
          const arrayIndex = Array.from(galleryItems).indexOf(targetItem);
          console.log('[Ramp Gallery] Target item found at array index:', arrayIndex);
          
          if (productPage.productSlider && productPage.productSlider.sliderEnabled) {
            console.log('[Ramp Gallery] Using slider, changing to array index:', arrayIndex);
            productPage.productSlider.changeSlide(arrayIndex);
          } else {
            console.log('[Ramp Gallery] Using scroll');
            window.scrollTo({
              top: targetItem.offsetTop + productPage.offsetTop,
              behavior: 'smooth'
            });
            if (productPage.thumbnailNavigationHelper) {
              productPage.thumbnailNavigationHelper(arrayIndex);
            }
          }
          
          if (productPage._pauseAllMedia) {
            productPage._pauseAllMedia();
          }
          if (productPage._playMedia) {
            productPage._playMedia(targetItem);
          }
        }, true);
      });
      
      console.log('[Ramp Gallery] Thumbnail navigation initialized');
    }, 1000);
  }
})();
